
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6mvtm", function(module, exports) {
$parcel$export(module.exports, "RELAY_API_CONTENTFUL", function () { return $e62c9da570d0cc47$export$7b31a9938ec3ba75; });
const $e62c9da570d0cc47$export$7b31a9938ec3ba75 = "contentful";

});

parcelRegister("3t7DW", function(module, exports) {
$parcel$export(module.exports, "init", function () { return $be9c067c7be4fda0$export$2cd8252107eb640b; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $yhhhl = parcelRequire("yhhhl");

var $konOj = parcelRequire("konOj");

var $f3gS9 = parcelRequire("f3gS9");

var $fuLgT = parcelRequire("fuLgT");

var $eQyIx = parcelRequire("eQyIx");

var $g0QpW = parcelRequire("g0QpW");

var $6mvtm = parcelRequire("6mvtm");

var $eRzlV = parcelRequire("eRzlV");

var $6r14Z = parcelRequire("6r14Z");

var $hgaI1 = parcelRequire("hgaI1");

var $7mHQv = parcelRequire("7mHQv");

var $i2Oi2 = parcelRequire("i2Oi2");

var $hZy36 = parcelRequire("hZy36");

var $3H7QB = parcelRequire("3H7QB");

var $hp3ar = parcelRequire("hp3ar");

var $gLm0b = parcelRequire("gLm0b");

var $6gQvZ = parcelRequire("6gQvZ");

var $idVA4 = parcelRequire("idVA4");

var $hu7gH = parcelRequire("hu7gH");
window.BUILD_KEY = "p-39fab6af7d";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $fuLgT.default)()
    }
};
(0, $hZy36.configureCastle)();
const $be9c067c7be4fda0$var$SUPPORTED_LOCALES = [
    {
        hrefLang: "ja",
        langRoute: "ja"
    },
    {
        hrefLang: "fr",
        langRoute: "fr"
    },
    {
        hrefLang: "de",
        langRoute: "de"
    },
    {
        hrefLang: "es",
        langRoute: "es"
    },
    {
        hrefLang: "pt-BR",
        langRoute: "br"
    },
    {
        hrefLang: "zh-Hans",
        langRoute: "zh"
    },
    {
        hrefLang: "ko",
        langRoute: "ko"
    },
    {
        hrefLang: "ru",
        langRoute: "ru"
    },
    {
        hrefLang: "pl",
        langRoute: "pl"
    },
    {
        hrefLang: "it",
        langRoute: "it"
    },
    {
        hrefLang: "nl",
        langRoute: "nl"
    }
];
const $be9c067c7be4fda0$export$2cd8252107eb640b = (Component, query, queryVars, relayApi)=>{
    const analyticsWebClient = (0, $g0QpW.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $hu7gH.parseRoute)(window.location);
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    const isPerfOnetrustEnabled = (0, $gLm0b.isPerformanceOnetrustEnabled)(typeof window !== "undefined" ? window.optanonConsentCookie : (0, $gLm0b.extractOptanonConsentCookie)(document.cookie), locationData);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    isPerfOnetrustEnabled && (0, $eQyIx.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $yhhhl.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $idVA4.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    if ((0, $hp3ar.isEdgeCachingPath)(window.location)) {
        // Override for Edge Caching
        (0, $hp3ar.overrideAjsAnonIdFromCookie)();
        (0, $hp3ar.overrideCustomAttributes)();
    }
    (0, $hgaI1.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(async ()=>{
        try {
            await (0, $3H7QB.DynamicConfigClient).getInstance().initialize({
                bootstrapValues: window.featureGateBootstrapValues
            });
        } catch (error) {
            console.error("Failed to initialize DynamicConfigClient", error);
        }
        const isStatic = typeof window !== "undefined" && window.IS_STATIC;
        const snapshot = window.relayStoreSnapshot;
        let relayBaseUrl = undefined;
        let relayAuthKey = undefined;
        if (relayApi === (0, $6mvtm.RELAY_API_CONTENTFUL)) {
            relayBaseUrl = (0, $eRzlV.CONTENTFUL_GRAPHQL_API_URL);
            relayAuthKey = window.CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES;
        }
        const relayEnvironment = (0, $i2Oi2.initRelayEnvironment)(snapshot, relayBaseUrl, relayAuthKey);
        const queryRef = (0, $f3gS9.loadQuery)(relayEnvironment, query, queryVars);
        const canonicalBaseUrl = (0, $6r14Z.getCanonicalBaseUrl)(window.location.hostname, path);
        const pathForCanonical = path ? (0, $6r14Z.canonicalPathForHref)(canonicalBaseUrl, path) : undefined;
        const route = pathForCanonical === undefined ? "" : pathForCanonical === "" ? "" : `/${pathForCanonical}`;
        const page = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6gQvZ.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $f3gS9.RelayEnvironmentProvider), {
                environment: relayEnvironment,
                children: [
                    isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                        rel: "canonical",
                        href: `${canonicalBaseUrl}${route}`
                    }),
                    isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                        rel: "alternate",
                        href: `${canonicalBaseUrl}${route}`,
                        hrefLang: "x-default"
                    }),
                    isStatic && $be9c067c7be4fda0$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                            rel: "alternate",
                            href: `${canonicalBaseUrl}/${langRoute}${route}`,
                            hrefLang: hrefLang
                        }, hrefLang)),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7mHQv.PageWrapper), {
                        analyticsWebClient: analyticsWebClient,
                        location: window.location,
                        pricing: window.prices,
                        availableProducts: window.availableProducts,
                        userProfile: window.userProfile,
                        userProfileStatus: window.userProfileStatus,
                        userContext: window.userContext,
                        userContextStatus: window.userContextStatus,
                        loggedOutContext: window.loggedOutContext,
                        loggedOutContextStatus: window.loggedOutContextStatus,
                        loggedInContext: window.loggedInContext,
                        loggedInContextStatus: window.loggedInContextStatus,
                        countryCode: window.countryCode,
                        mlTemplateIds: window.mlTemplateIds,
                        keyword: window.keyword,
                        anchor: window.anchor,
                        subAnchor: window.subAnchor,
                        queryRef: queryRef,
                        PageComponent: Component,
                        transactionAccounts: window.transactionAccounts,
                        userAgent: userAgent
                    })
                ]
            })
        });
        if (isStatic) {
            // @ts-expect-error type
            const root = (0, $konOj.createRoot)(document.getElementById("wac"));
            root.render(page);
        } else (0, $konOj.hydrateRoot)(// @ts-expect-error type
        document.getElementById("wac-root"), page, {
            onRecoverableError: (error, errorInfo)=>{
                document.getElementById("wac-root")?.setAttribute("hydration-error", "true");
            }
        });
    });
};

});
parcelRegister("i2Oi2", function(module, exports) {
$parcel$export(module.exports, "initRelayEnvironment", function () { return $36b5b9e576032b2f$export$1456be3de97c862f; });

var $gRpMo = parcelRequire("gRpMo");
(0, $gRpMo.RelayFeatureFlags).ENABLE_LOAD_QUERY_REQUEST_DEDUPING = true;
// TODO: Lift this into environment
const $36b5b9e576032b2f$var$GATEWAY_URL = "https://www.atlassian.com/gateway/api/graphql";
function $36b5b9e576032b2f$var$createRelayEnvironment(initialRecords, baseUrlOverride, authToken) {
    const baseUrl = baseUrlOverride ?? $36b5b9e576032b2f$var$GATEWAY_URL;
    let headers = {
        "Content-Type": "application/json"
    };
    if (authToken) headers = Object.assign({}, headers, {
        Authorization: `Bearer ${authToken}`
    });
    const fetchResponse = (params, variables)=>{
        const startTime = Date.now();
        const response = fetch(baseUrl, {
            method: "POST",
            headers: headers,
            // Contentful uses an authToken, and Access-Control-Allow-Origin = "*",
            // therefore we cannot include credentials for Contentful queries
            credentials: authToken ? "same-origin" : "include",
            body: JSON.stringify({
                query: params.text,
                variables: variables
            })
        });
        return (0, $gRpMo.Observable).from(response.then(async (res)=>{
            const duration = Date.now() - startTime;
            // @ts-ignore
            if (!globalThis.IS_STATIC) try {
                // @ts-ignore
                globalThis.metrics.histogram(`contentful.duration`, "10_100_500_1000_2000_3000_5000_10000_30000", duration, {
                    gqlOperationName: params.name,
                    cacheStatus: res.headers.get("x-cache"),
                    status: res.status
                });
            } catch (e) {
                console.error(`Failed to track ${params.name} call`, e);
            }
            return res.json();
        }));
    };
    const network = (0, $gRpMo.Network).create(fetchResponse);
    const store = new (0, $gRpMo.Store)(new (0, $gRpMo.RecordSource)(initialRecords));
    return new (0, $gRpMo.Environment)({
        network: network,
        store: store
    });
}
let $36b5b9e576032b2f$var$clientSideRelayEnvironment;
function $36b5b9e576032b2f$export$1456be3de97c862f(initialRecords, baseUrlOverride, authToken) {
    const environment = $36b5b9e576032b2f$var$clientSideRelayEnvironment ?? $36b5b9e576032b2f$var$createRelayEnvironment(initialRecords, baseUrlOverride, authToken);
    if (typeof window === "undefined") return environment;
    if (!$36b5b9e576032b2f$var$clientSideRelayEnvironment) $36b5b9e576032b2f$var$clientSideRelayEnvironment = environment;
    else if (initialRecords) environment.getStore().publish(new (0, $gRpMo.RecordSource)(initialRecords));
    return $36b5b9e576032b2f$var$clientSideRelayEnvironment;
}

});


parcelRegister("7Lagj", function(module, exports) {
$parcel$export(module.exports, "NonProfitPricingPage", function () { return $00749ab74f7d8f60$export$536ddfd40654e3e4; });

var $7VQPk = parcelRequire("7VQPk");

var $dl2JF = parcelRequire("dl2JF");

var $hkAZ4 = parcelRequire("hkAZ4");
const $00749ab74f7d8f60$export$536ddfd40654e3e4 = ({ pricing: pricing, countryCode: countryCode, pricingContent: pricingContent, queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dl2JF.PricingContentContextProviderRelay), {
        productId: "nonprofit",
        pricingContent: pricingContent,
        queryRef: queryRef,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            "data-testid": "non-profit-pricing",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hkAZ4.NonProfitPricingPageTemplate), {
                pricing: pricing,
                countryCode: countryCode
            })
        })
    });
};

});
parcelRegister("hkAZ4", function(module, exports) {
$parcel$export(module.exports, "NonProfitPricingPageTemplate", function () { return $3183adb2da196ae8$export$55cf024acc460d8c; });

var $7VQPk = parcelRequire("7VQPk");

var $dl2JF = parcelRequire("dl2JF");

var $bE8d4 = parcelRequire("bE8d4");

var $grcEk = parcelRequire("grcEk");

var $9Url8 = parcelRequire("9Url8");

var $5S2vX = parcelRequire("5S2vX");

var $9RHgs = parcelRequire("9RHgs");

var $kvg9i = parcelRequire("kvg9i");

var $gaPqz = parcelRequire("gaPqz");

var $btggB = parcelRequire("btggB");

var $vCUGX = parcelRequire("vCUGX");

var $g7wmQ = parcelRequire("g7wmQ");

var $fZJZd = parcelRequire("fZJZd");

var $4bEWc = parcelRequire("4bEWc");

var $71t0B = parcelRequire("71t0B");

var $gtK7Z = parcelRequire("gtK7Z");

var $k53CY = parcelRequire("k53CY");

var $lSpoK = parcelRequire("lSpoK");

var $hJy82 = parcelRequire("hJy82");

var $3icmm = parcelRequire("3icmm");

var $in9in = parcelRequire("in9in");
const $3183adb2da196ae8$export$55cf024acc460d8c = ({ pricing: pricing, countryCode: countryCode })=>{
    const content = (0, $dl2JF.usePricingContentContext)();
    const isGwp10027NonprofitPricingPage = (0, $btggB.getIsGwp10027NonprofitPricingPage)();
    if (isGwp10027NonprofitPricingPage) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $vCUGX.NonProfitPricingPageTemplateWithTwc), {});
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
            pageId: "nonprofit-pricing-page",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    nav: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lSpoK.NonprofitNav), {}),
                    banner: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g7wmQ.Banner), {}),
                    hero: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gtK7Z.Hero), {}),
                    hasGlobalFooter: false
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    bgColor: "#F8F8F8",
                    hasGlobalFooter: false,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fZJZd.EligibleSection), {})
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    hasGlobalFooter: false,
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k53CY.NonprofitCalculatorHeading), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9RHgs.PricingTabs), {
                                jiraCalculatorComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gaPqz.JiraPriceFinder), {
                                    pricing: pricing,
                                    countryCode: countryCode,
                                    shouldAddDiscount: true
                                }),
                                confluenceCalculatorComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kvg9i.ConfluencePriceFinder), {
                                    pricing: pricing,
                                    countryCode: countryCode,
                                    shouldAddDiscount: true
                                }),
                                trelloCalculatorComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $in9in.TrelloPriceFinder), {
                                    pricing: pricing,
                                    countryCode: countryCode,
                                    shouldAddDiscount: true
                                }),
                                loomCalculatorComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9Url8.LoomPriceFinder), {
                                    pricing: pricing,
                                    countryCode: countryCode,
                                    shouldAddDiscount: true,
                                    ctaUrlSource: "productPlans"
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4bEWc.EnterpriseSection), {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    bgColor: "#E9F2FE",
                    hasGlobalFooter: false,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hJy82.OfficialSection), {})
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    hasGlobalFooter: false,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3icmm.ResourcesSection), {})
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    hasGlobalFooter: true,
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bE8d4.PricingFaq), {
                                header: content?.getMoreDetailsTitle,
                                planDetails: content?.additionalDetails
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $71t0B.Fineprint), {})
                        ]
                    })
                })
            ]
        })
    });
};

});
parcelRegister("grcEk", function(module, exports) {
$parcel$export(module.exports, "PricingPageLayout", function () { return $229e6cc32b6909b5$export$179602f42864b2b8; });
/* pricing-page-layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iLjCW = parcelRequire("iLjCW");

var $jvvcS = parcelRequire("jvvcS");
const $229e6cc32b6909b5$export$179602f42864b2b8 = ({ nav: nav, banner: banner, hero: hero, bgColor: bgColor, hasGlobalFooter: hasGlobalFooter = true, showFallback: showFallback = false, children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            nav && nav,
            !showFallback && banner,
            !showFallback && hero,
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: {
                    background: bgColor
                },
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _1q51vbgk _85i5vbgk _xc2ickbl _1u2qzwfg"
                ]),
                children: [
                    showFallback && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jvvcS.PricingPageFallback), {}),
                    !showFallback && children && /*#__PURE__*/ (0, $7VQPk.jsx)("main", {
                        id: "content",
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _zulpvbgk _p12ftfvk _1bsbaq80 _vqct1h22 _1wfq1ul9 _15vt1ul9 _v7361wqb _chtu1wqb _8164ckbl _63vr1vh9 _1tbz1ul9 _68811ul9"
                        ]),
                        children: children
                    })
                ]
            }),
            hasGlobalFooter && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1pfhvbgk _476dckbl"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iLjCW.GlobalFooter), {})
            })
        ]
    });
};
const $229e6cc32b6909b5$var$footerCss = null;
const $229e6cc32b6909b5$var$pricingPageLayoutOuterCss = null;
const $229e6cc32b6909b5$var$pricingPageLayoutInnerCss = null;

});
parcelRegister("jvvcS", function(module, exports) {
$parcel$export(module.exports, "PricingPageFallback", function () { return $a5f2023cdede46a1$export$54fc8f6b9874893e; });
/* pricing-page-fallback.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
const $a5f2023cdede46a1$export$54fc8f6b9874893e = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4t3idtre _1e0c1txw _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "PageFallback.message",
            defaultMessage: "An unexpected error occurred. Please try again later."
        })
    });
};

});


parcelRegister("9Url8", function(module, exports) {
$parcel$export(module.exports, "LoomPriceFinder", function () { return $44da10c9bd623a4e$export$4377a557bebc94dd; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $fnHPc = parcelRequire("fnHPc");
var $iVyKn = parcelRequire("iVyKn");

var $hCc2m = parcelRequire("hCc2m");

var $k6638 = parcelRequire("k6638");

var $g9ZvA = parcelRequire("g9ZvA");

var $gIRO7 = parcelRequire("gIRO7");

var $eYlij = parcelRequire("eYlij");

var $1qGP5 = parcelRequire("1qGP5");

var $dl2JF = parcelRequire("dl2JF");

var $17RBn = parcelRequire("17RBn");

var $crD7r = parcelRequire("crD7r");

var $dQswK = parcelRequire("dQswK");
const $44da10c9bd623a4e$export$4377a557bebc94dd = (props)=>{
    const content = {
        free: (0, $dl2JF.usePricingPlanComparison)("Starter"),
        standard: (0, $dl2JF.usePricingPlanComparison)("Business"),
        premium: (0, $dl2JF.usePricingPlanComparison)("Business + AI"),
        enterprise: (0, $dl2JF.usePricingPlanComparison)("Enterprise")
    };
    const freePlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "free");
    const standardPlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "standard");
    const premiumPlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "premium");
    const enterprisePlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "enterprise");
    const loomProductPlans = [
        {
            planName: "Starter",
            offeringSku: "loom-free-sku",
            recommendationLimit: Infinity,
            signupLimit: 50000,
            planFeatureMessages: freePlanFeatureMessages,
            description: content.free?.planOneLiner ?? "",
            signupURLSuffix: (0, $dQswK.SIGNUP_URL_QUERY_PREMIUM)
        },
        {
            planName: "Business",
            offeringSku: "loom-business-sku",
            recommendationLimit: Infinity,
            signupLimit: 50000,
            planFeatureMessages: standardPlanFeatureMessages,
            description: content.standard?.planOneLiner ?? "",
            signupURLSuffix: (0, $dQswK.SIGNUP_URL_QUERY_PREMIUM)
        },
        {
            planName: "Business + AI",
            planTitleComponent: (0, $crD7r.LoomAiTitle),
            offeringSku: "loom-business-ai-sku",
            recommendationLimit: 0,
            signupLimit: 50000,
            planFeatureMessages: premiumPlanFeatureMessages,
            description: content.premium?.planOneLiner ?? "",
            signupURLSuffix: (0, $dQswK.SIGNUP_URL_QUERY_PREMIUM)
        },
        {
            planName: "Enterprise",
            offeringSku: "loom-enterprise-sku",
            recommendationLimit: Infinity,
            signupLimit: 50000,
            planFeatureMessages: enterprisePlanFeatureMessages,
            description: content.enterprise?.planOneLiner ?? ""
        }
    ];
    let cardEnterpriseBodyOverride = /*#__PURE__*/ (0, $7VQPk.jsx)("div", {});
    const locale = (0, $17RBn.useLocale)();
    if (locale === "en") cardEnterpriseBodyOverride = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
        variant: "xl",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "LoomPriceFinderTeam25.cardEnterpriseBodyOverride",
            defaultMessage: "Let's talk"
        })
    });
    const messages = (0, $fnHPc.defineMessages)({
        unitCountInputTextRedesign: {
            id: "LoomPriceFinderTeam25.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        unitCountInputTerm: {
            id: "LoomPriceFinderTeam25.unitCountInputTerm",
            defaultMessage: "users"
        },
        billingCycleText: {
            id: "LoomPriceFinderTeam25.billingCycleText",
            defaultMessage: "Billing cycle:"
        },
        cardOverSignupLimit: {
            id: "LoomPriceFinderTeam25.cardOverSignupLimit",
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: "LoomPriceFinderTeam25.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardUnitCountTierRange: {
            id: "LoomPriceFinderTeam25.cardUnitCountTierRange",
            defaultMessage: "User tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "LoomPricingPage.priceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per user / month"
        },
        cardEnterpriseBodyOverride: // @ts-ignore
        cardEnterpriseBodyOverride
    });
    const recommendationElement = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "LoomPriceFinderTeam25.recommendationElement",
        defaultMessage: "Most popular"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hCc2m.default), {
        interactionName: "loom-price-finder",
        fallback: (0, $g9ZvA.LoadingSpinner),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eYlij.PriceFinderContextProvider), {
            dataProductKey: "loom",
            productPlans: loomProductPlans,
            defaultUnitCount: 100,
            shouldAddDiscount: props.shouldAddDiscount,
            annualUserTierDisplayThreshold: 26,
            recommendationElement: recommendationElement,
            ctaUrlSource: props.ctaUrlSource,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gIRO7.default), {
                messages: messages,
                serverSideCCPPricing: props.pricing?.ccpPricingData?.loom,
                countryCode: props.countryCode
            })
        })
    });
};
$44da10c9bd623a4e$export$4377a557bebc94dd.displayName = "LoomPriceFinder";

});
parcelRegister("1qGP5", function(module, exports) {
$parcel$export(module.exports, "createPlanFeatureMessages", function () { return $9f8554c0837366fe$export$8fd76139fda318d8; });

var $7VQPk = parcelRequire("7VQPk");
const $9f8554c0837366fe$export$68568ac1e2cced1f = (highlightedFeatures)=>{
    return highlightedFeatures.map((highlight)=>({
            featureMessage: highlight.highlightedFeatureDetails ? {
                text: highlight.highlightedFeatureTitleExternal,
                content: ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: highlight.highlightedFeatureDetails
                        }
                    })
            } : highlight.highlightedFeatureTitleExternal,
            lozengeText: highlight.callOut
        }));
};
const $9f8554c0837366fe$export$8fd76139fda318d8 = (content, planKey)=>{
    const plan = content?.[planKey];
    return plan?.highlightedFeaturesContainer ? $9f8554c0837366fe$export$68568ac1e2cced1f(plan.highlightedFeaturesContainer) : [];
};

});

parcelRegister("crD7r", function(module, exports) {
$parcel$export(module.exports, "LoomAiTitle", function () { return $981d3821a6ea456e$export$930d845fa234c9bc; });

var $7VQPk = parcelRequire("7VQPk");

var $lP7A9 = parcelRequire("lP7A9");

var $hnmMQ = parcelRequire("hnmMQ");
const $981d3821a6ea456e$export$930d845fa234c9bc = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
        id: `pricing-plan-title-${props.planName}`,
        children: [
            props.planName,
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/y42547423ap63hd11cr1832n3n455pt5.webp",
                    alt: ""
                },
                style: {
                    height: "17px",
                    width: "17px",
                    position: "relative",
                    insetInlineStart: (0, $lP7A9.default)("space.025"),
                    insetBlockEnd: (0, $lP7A9.default)("space.050")
                }
            })
        ]
    });
};

});

parcelRegister("dQswK", function(module, exports) {
$parcel$export(module.exports, "SIGNUP_URL_QUERY_PREMIUM", function () { return $8f236d094af265c8$export$ff7054db20c33aeb; });
$parcel$export(module.exports, "usePremiumSignupUrl", function () { return $8f236d094af265c8$export$aa185ad968f4b15f; });

var $jQ0cd = parcelRequire("jQ0cd");
const $8f236d094af265c8$export$ff7054db20c33aeb = "?bundle=loom&edition=premium";
const $8f236d094af265c8$export$aa185ad968f4b15f = ()=>(0, $jQ0cd.useLocalizedHref)(`/try/cloud/signup${$8f236d094af265c8$export$ff7054db20c33aeb}`);

});


parcelRegister("5S2vX", function(module, exports) {
$parcel$export(module.exports, "useParentScrollTracking", function () { return $d703c208f3e9c795$export$164ddb76b909974a; });
$parcel$export(module.exports, "ParentScrollTracking", function () { return $d703c208f3e9c795$export$248f1dfc9396e7e4; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $je135 = parcelRequire("je135");
const $d703c208f3e9c795$var$ScrollTrackingContext = /*#__PURE__*/ (0, $1oC0p.createContext)({
    pageId: "wac-web",
    scrollTrackingEnabled: true
});
const $d703c208f3e9c795$export$164ddb76b909974a = ()=>{
    return (0, $1oC0p.useContext)($d703c208f3e9c795$var$ScrollTrackingContext);
};
const $d703c208f3e9c795$export$248f1dfc9396e7e4 = (props)=>{
    const parentContext = $d703c208f3e9c795$export$164ddb76b909974a();
    const arrayChildren = (0, $1oC0p.Children).toArray(props.children);
    const definedName = (child)=>{
        if (/*#__PURE__*/ (0, $1oC0p.isValidElement)(child) && child.type) {
            // Use a type assertion to tell TypeScript that the type has a displayName
            const namedComponent = child.type;
            return namedComponent.displayName;
        } else return undefined;
    };
    // Determine tracking of parent undefined means true
    const parentTrackScrolling = parentContext.scrollTrackingEnabled === undefined ? true : parentContext.scrollTrackingEnabled;
    // Parent should take precedence if parent tracking is disabled
    const trackScrolling = parentTrackScrolling && (props.scrollTrackingEnabled === undefined ? true : props.scrollTrackingEnabled);
    const pageId = props.pageId ?? parentContext.pageId;
    return /*#__PURE__*/ (0, $7VQPk.jsx)($d703c208f3e9c795$var$ScrollTrackingContext.Provider, {
        value: {
            pageId: pageId,
            scrollTrackingEnabled: trackScrolling
        },
        children: (0, $1oC0p.Children).map(arrayChildren, (child, index)=>{
            const name = definedName(child);
            return name ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $je135.ScrollTracking), {
                index: `${index}/${arrayChildren.length}`,
                section: name,
                as: props.as,
                children: child
            }, index) : child;
        })
    });
};

});
parcelRegister("je135", function(module, exports) {
$parcel$export(module.exports, "useScrollTracking", function () { return $0fbf1a9bc3d0315b$export$17700584f55fbc70; });
$parcel$export(module.exports, "ScrollTracking", function () { return $0fbf1a9bc3d0315b$export$1725757b7947b890; });
$parcel$export(module.exports, "withScrollTracking", function () { return $0fbf1a9bc3d0315b$export$391633ede08dabb1; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $jKShK = parcelRequire("jKShK");

var $eY3N6 = parcelRequire("eY3N6");

var $5S2vX = parcelRequire("5S2vX");

var $iSeHD = parcelRequire("iSeHD");
const $0fbf1a9bc3d0315b$export$17700584f55fbc70 = (section, props = {})=>{
    const { index: index, observerOptions: observerOptions, dwellTimeEnabled: dwellTimeEnabled, additionalAttributes: additionalAttributes } = props;
    const hasFunctionBeenCalled = (0, $1oC0p.useRef)(false);
    const scrollPercentage = (0, $1oC0p.useRef)(0);
    const { pageId: pageId, scrollTrackingEnabled: scrollTrackingEnabled } = (0, $5S2vX.useParentScrollTracking)();
    const { ref: ref, inView: inView, entry: entry } = (0, $jKShK.useInView)({
        threshold: 0.5,
        triggerOnce: true,
        ...observerOptions,
        skip: observerOptions?.skip || !scrollTrackingEnabled
    });
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleScroll = ()=>{
        const windowHeight = window.innerHeight;
        const fullHeight = document.documentElement.scrollHeight;
        const currentPosition = window.scrollY;
        scrollPercentage.current = Math.round(currentPosition / (fullHeight - windowHeight) * 100);
    };
    (0, $1oC0p.useEffect)(()=>{
        if (inView && !hasFunctionBeenCalled.current && section) {
            handleScroll();
            const scrollTrackAnalyticsPayload = {
                eventType: "ui",
                action: "scrolledTo",
                actionSubject: "section",
                source: window.location.pathname,
                attributes: {
                    section: section,
                    scrollPercentage: scrollPercentage.current,
                    pageChildIndex: index,
                    pageId: pageId,
                    ...additionalAttributes
                }
            };
            const dwellTimeTrackAnalyticsPayload = {
                eventType: "ui",
                action: "dwellTimeTracked",
                actionSubject: "section",
                source: window.location.pathname,
                attributes: {
                    section: section,
                    scrollPercentage: scrollPercentage.current,
                    pageChildIndex: index,
                    pageId: pageId,
                    ...additionalAttributes
                }
            };
            if (analyticsClient) {
                createAnalyticsEvent({
                    ...scrollTrackAnalyticsPayload
                }).fire();
                hasFunctionBeenCalled.current = true;
            }
            if (dwellTimeEnabled) {
                const activityEvents = [
                    "mousemove",
                    "keydown",
                    "scroll",
                    "touchstart"
                ];
                let intervalId = undefined;
                let activityTimeout = undefined;
                let active = true;
                // stop tracking after 1 minute of inactivity
                const setActive = ()=>{
                    active = true;
                    clearTimeout(activityTimeout);
                    activityTimeout = setTimeout(()=>{
                        active = false;
                    }, 60000);
                };
                activityEvents.forEach((evt)=>{
                    window.addEventListener(evt, setActive);
                });
                // emmit every 5 seconds if the user is active
                intervalId = setInterval(()=>{
                    if (active) {
                        handleScroll();
                        createAnalyticsEvent({
                            ...dwellTimeTrackAnalyticsPayload
                        }).fire();
                    } else {
                        clearInterval(intervalId);
                        clearTimeout(activityTimeout);
                        activityEvents.forEach((evt)=>{
                            window.removeEventListener(evt, setActive);
                        });
                    }
                }, 5000);
            }
        }
    }, [
        additionalAttributes,
        analyticsClient,
        createAnalyticsEvent,
        dwellTimeEnabled,
        hasFunctionBeenCalled,
        inView,
        index,
        pageId,
        section
    ]);
    return {
        ref: ref,
        inView: inView,
        entry: entry
    };
};
const $0fbf1a9bc3d0315b$export$1725757b7947b890 = ({ section: section, index: index, observerOptions: observerOptions, children: children, as: RootElement = "div" })=>{
    const { ref: ref } = $0fbf1a9bc3d0315b$export$17700584f55fbc70(section, {
        index: index,
        observerOptions: observerOptions
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)(RootElement, {
        ref: ref,
        children: children
    });
};
function $0fbf1a9bc3d0315b$export$391633ede08dabb1(section, InnerComponent, options) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (props)=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)($0fbf1a9bc3d0315b$export$1725757b7947b890, {
            section: section,
            ...options,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)(InnerComponent, {
                ...props
            })
        });
    };
}

});


parcelRegister("9RHgs", function(module, exports) {
$parcel$export(module.exports, "PricingTabs", function () { return $85217f2010396a88$export$72a589327a08c3da; });
/* tabs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $a9CD6 = parcelRequire("a9CD6");

var $1OyVz = parcelRequire("1OyVz");

var $hK1eD = parcelRequire("hK1eD");

var $98rQm = parcelRequire("98rQm");

var $iyxHK = parcelRequire("iyxHK");

var $gGOh9 = parcelRequire("gGOh9");
const $85217f2010396a88$var$tabStyles = null;
const $85217f2010396a88$export$72a589327a08c3da = ({ jiraCalculatorComponent: jiraCalculatorComponent, confluenceCalculatorComponent: confluenceCalculatorComponent, trelloCalculatorComponent: trelloCalculatorComponent, loomCalculatorComponent: loomCalculatorComponent, teamworkCollectionComponent: teamworkCollectionComponent, dataProductKey: dataProductKey, banner: banner })=>{
    const intl = (0, $8e22h.default)();
    const defaultProductKey = "nonProfitCalculator";
    const defaultJiraCalculatorComponent = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: "Default Jira Component"
        });
    const defaultConfluenceCalculatorComponent = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: "Default Confluence Component"
        });
    const defaultTrelloCalculatorComponent = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: "Default Trello Component"
        });
    const defaultLoomCalculatorComponent = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: "Default Loom Component"
        });
    const defaultTeamworkCollectionCalculatorComponent = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: "Default Loom Component"
        });
    const JiraComponent = jiraCalculatorComponent ?? defaultJiraCalculatorComponent;
    const ConfluenceComponent = confluenceCalculatorComponent ?? defaultConfluenceCalculatorComponent;
    const TrelloComponent = trelloCalculatorComponent ?? defaultTrelloCalculatorComponent;
    const LoomComponent = loomCalculatorComponent ?? defaultLoomCalculatorComponent;
    const TeamworkCollectionComponent = teamworkCollectionComponent ?? defaultTeamworkCollectionCalculatorComponent;
    const possibleTabs = [
        {
            id: "jira",
            textLabel: intl.formatMessage({
                id: "PricingTabs.jira",
                defaultMessage: "Jira"
            }),
            component: typeof JiraComponent === "function" ? /*#__PURE__*/ (0, $7VQPk.jsx)(JiraComponent, {}) : JiraComponent,
            iconBefore: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1OyVz.JiraMarkBrand), {
                className: "logoSize"
            }),
            isAvailable: Boolean(jiraCalculatorComponent)
        },
        {
            id: "confluence",
            textLabel: intl.formatMessage({
                id: "PricingTabs.confluence",
                defaultMessage: "Confluence"
            }),
            component: typeof ConfluenceComponent === "function" ? /*#__PURE__*/ (0, $7VQPk.jsx)(ConfluenceComponent, {}) : ConfluenceComponent,
            iconBefore: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9CD6.ConfluenceMarkBrand), {
                className: "logoSize"
            }),
            isAvailable: Boolean(confluenceCalculatorComponent)
        },
        {
            id: "loom",
            textLabel: intl.formatMessage({
                id: "PricingTabs.loom",
                defaultMessage: "Loom"
            }),
            component: typeof LoomComponent === "function" ? /*#__PURE__*/ (0, $7VQPk.jsx)(LoomComponent, {}) : LoomComponent,
            iconBefore: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hK1eD.LoomMarkBrandV2), {
                className: "logoSize"
            }),
            isAvailable: Boolean(loomCalculatorComponent)
        },
        {
            id: "trello",
            textLabel: intl.formatMessage({
                id: "PricingTabs.trello",
                defaultMessage: "Trello"
            }),
            component: typeof TrelloComponent === "function" ? /*#__PURE__*/ (0, $7VQPk.jsx)(TrelloComponent, {}) : TrelloComponent,
            iconBefore: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $98rQm.TrelloMarkBrand), {
                className: "logoSize"
            }),
            isAvailable: Boolean(trelloCalculatorComponent)
        },
        {
            id: "teamwork-collection",
            elementLabel: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_161tnagk _1lve1osq _1m8i1w81 _1pww1wug _eaz5idpf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iyxHK.CollectionTeamworkLogoBrandV3), {})
            }),
            textLabel: intl.formatMessage({
                id: "PricingTabs.teamworkCollection",
                defaultMessage: "Teamwork Collection"
            }),
            component: typeof TeamworkCollectionComponent === "function" ? /*#__PURE__*/ (0, $7VQPk.jsx)(TeamworkCollectionComponent, {}) : TeamworkCollectionComponent,
            isAvailable: Boolean(teamworkCollectionComponent)
        }
    ];
    const tabs = possibleTabs.filter((tab)=>tab.isAvailable);
    const defaultBanner = intl.formatMessage({
        id: "tabGroup.banner",
        defaultMessage: "showing 75% off"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_p12f1osq _1kde1ule _5pbc1f4h _mp6aglyw _1v4zidpf _1n3n1osq _si4cgrf3 _1p4fgrf3 _r7togrf3 _17a1grf3 _1ypridpf _n8lpka7h _9ss6idpf _cy2pka7h _11cq1txw _1b5s1h6o _1rvg1h6o _jmjjr3uz _inr21rga _u4d1idpf _1v9nh2mm _7l98t94y _1bvkvle5 _1gvk1x1l _150515x9 _1afqkb7n _1b7v1crf _pu7u1crf _kqje1crf _16vm1crf _rclkls4b _12lk189y _f40hcd5j _wx5ocd5j _1lxt1hdd _xaq61hdd _qr3omwu3 _1xrymwu3 _1lx01r31 _xx3h1r31 _1lleglyw _dqzjglyw _u4pp1o36 _12t91o36 _1s6ccs5v _1jp7cs5v _1lp7bsef _2g4515iw _dt8dglyw _929l14y2 _15uvglyw _1schglyw _1qmzglyw _1fv4glyw _a47gglyw _fp1f7vkz _ipo11crf _mzrv1git _1plp1osq _1ckkidpf _o6gx1wug _1bmhidpf _196a1wug _mzhvidpf _113widpf _12kyidpf _1vg7idpf _w4c110yn _9kzd10yn _1qsfglyw _fe4v7vkz _1x987vkz _1pqlidpf _1lp010j7"
        ]),
        style: {
            "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100")),
            "--_sse8eq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark900")),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gGOh9.TabsCustom), {
            id: "pricingtabs",
            label: "pricing tabs",
            headerText: "",
            bodyText: "",
            className: "pricing-tabs",
            tabs: tabs,
            dataProductKey: dataProductKey ?? defaultProductKey,
            banner: banner ?? defaultBanner
        })
    });
};
$85217f2010396a88$export$72a589327a08c3da.displayName = "TabbedCalculatorSection";

});
parcelRegister("hK1eD", function(module, exports) {
$parcel$export(module.exports, "LoomMarkBrandV2", function () { return $f58adaea274070d6$export$e783a4d8175ce805; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $4OgEb = parcelRequire("4OgEb");
const $f58adaea274070d6$export$e783a4d8175ce805 = ({ width: width = "100%", height: height = "100%", className: className, ...rest })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M41 22.1094H31.0579L39.6682 17.1383L37.7774 13.8622L29.167 18.8334L34.1371 10.2237L30.861 8.33173L25.891 16.9414V7H22.109V16.9423L17.137 8.33173L13.862 10.2228L18.833 18.8324L10.2227 13.8622L8.33169 17.1373L16.942 22.1085H7V25.8906H16.9411L8.33169 30.8617L10.2227 34.1378L18.8321 29.1676L13.8611 37.7772L17.137 39.6682L22.1081 31.0577V41H25.8901V31.0586L30.8601 39.6682L34.136 37.7772L29.1651 29.1667L37.7754 34.1378L39.6664 30.8617L31.057 25.8915H40.998V22.1094H41ZM24 29.1437C21.1483 29.1437 18.8368 26.8324 18.8368 23.9805C18.8368 21.1287 21.1483 18.8172 24 18.8172C26.8517 18.8172 29.1631 21.1287 29.1631 23.9805C29.1631 26.8324 26.8517 29.1437 24 29.1437Z",
            fill: "#625DF5"
        })
    });
$f58adaea274070d6$export$e783a4d8175ce805.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).number
    ]),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).number
    ]),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).string
};

});

parcelRegister("gGOh9", function(module, exports) {
$parcel$export(module.exports, "TabsCustom", function () { return $e3221c0f304a7ad7$export$da3a983bae6b9d3a; });
/* tabs-custom.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $2ivuE = parcelRequire("2ivuE");

var $2CA9S = parcelRequire("2CA9S");

var $iPPTB = parcelRequire("iPPTB");

var $1rGpC = parcelRequire("1rGpC");

var $b4FXR = parcelRequire("b4FXR");
const $e3221c0f304a7ad7$var$CustomTabsStyle = null;
const $e3221c0f304a7ad7$export$da3a983bae6b9d3a = ({ id: id, label: label, headerText: headerText, bodyText: bodyText, tabs: tabs, dataProductKey: dataProductKey, colors: colors, ctaProps: ctaProps, linkPosition: linkPosition = "bottom", backgroundProperties: backgroundProperties, className: className, banner: banner })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b4FXR.StyledBackground), {
        ...backgroundProperties,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1yt41d5t _13zni5hb _15tx1jx0",
                className
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), {
                        headerText: headerText,
                        headerType: "h2",
                        bodyText: bodyText,
                        isCentered: true,
                        ctaProps: linkPosition === "top" && ctaProps?.primaryLinkProps ? ctaProps : {}
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2CA9S.TabGroup), {
                        colors: colors,
                        tabContentType: "custom",
                        tabs: tabs,
                        id: id,
                        label: label,
                        dataProductKey: dataProductKey,
                        banner: banner
                    })
                }),
                linkPosition === "bottom" && ctaProps?.primaryLinkProps ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_y3gn1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                            ...ctaProps.primaryLinkProps,
                            text: ctaProps.primaryLinkProps.text,
                            "aria-label": ctaProps.primaryLinkProps.text
                        })
                    })
                }) : null
            ]
        })
    });
};

});
parcelRegister("b4FXR", function(module, exports) {
$parcel$export(module.exports, "StyledBackground", function () { return $5e184c6b078bec45$export$d5a32b9384a657de; });
/* styled-backgrounds.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $c9xu6 = parcelRequire("c9xu6");
const $5e184c6b078bec45$var$positioner = {
    cornerTopLeft: "top left",
    cornerTopRight: "top right",
    cornerBottomLeft: "bottom left",
    cornerBottomRight: "bottom right",
    sideTop: "center top",
    sideLeft: "left center",
    sideRight: "right center",
    sideBottom: "center bottom",
    hidden: "-100% -100%"
};
const $5e184c6b078bec45$var$sizes = {
    desktop: {
        cornerTopLeft: "400px auto",
        cornerTopRight: "400px auto",
        cornerBottomLeft: "400px auto",
        cornerBottomRight: "400px auto",
        sideTop: "auto 150px",
        sideLeft: "400px auto",
        sideRight: "400px auto",
        sideBottom: "auto 150px",
        hidden: "0 0"
    },
    tablet: {
        cornerTopLeft: "auto 50%",
        cornerTopRight: "auto 50%",
        cornerBottomLeft: "auto 50%",
        cornerBottomRight: "auto 50%",
        sideTop: "auto 150px",
        sideLeft: "calc(50% - 350px) auto",
        sideRight: "calc(50% - 350px) auto",
        sideBottom: "auto 150px",
        hidden: "0 0"
    },
    mobile: {
        cornerTopLeft: "auto 200px",
        cornerTopRight: "auto 200px",
        cornerBottomLeft: "auto 200px",
        cornerBottomRight: "auto 200px",
        sideTop: "auto 150px",
        sideLeft: "50%",
        sideRight: "50%",
        sideBottom: "auto 200px",
        hidden: "0 0"
    }
};
const $5e184c6b078bec45$var$getBGObject = (bg)=>{
    return {
        src: `url(${bg.imageLink})`,
        posDesktop: $5e184c6b078bec45$var$positioner[bg.positionDesktop],
        posTablet: $5e184c6b078bec45$var$positioner[bg.positionTablet],
        posMobile: $5e184c6b078bec45$var$positioner[bg.positionMobile],
        sizeDesktop: $5e184c6b078bec45$var$sizes.desktop[bg.positionDesktop],
        sizeTablet: $5e184c6b078bec45$var$sizes.tablet[bg.positionTablet],
        sizeMobile: $5e184c6b078bec45$var$sizes.mobile[bg.positionMobile]
    };
};
const $5e184c6b078bec45$export$d5a32b9384a657de = (backgroundProperties)=>{
    const obj = backgroundProperties || {};
    const hasGradient = obj.gradientDirection && obj.bgColor && obj.bgColor2;
    const totalBGs = [];
    const collections = {
        desktop: {
            topCorners: false,
            bottomCorners: false
        },
        tablet: {
            topCorners: false,
            bottomCorners: false
        },
        mobile: {
            topCorners: false,
            bottomCorners: false
        }
    };
    if (hasGradient) totalBGs.unshift({
        src: (0, $c9xu6.getGradient)(obj.gradientDirection, obj.bgColor, obj.bgColor2),
        posDesktop: "top left",
        posTablet: "top left",
        posMobile: "top left",
        sizeDesktop: "100% 100%",
        sizeTablet: "100% 100%",
        sizeMobile: "100% 100%"
    });
    if (obj.bgImage) totalBGs.unshift({
        src: `url(${obj.bgImage} )`,
        posDesktop: "center center",
        posTablet: "center center",
        posMobile: "center center",
        sizeDesktop: "cover",
        sizeTablet: "cover",
        sizeMobile: "cover"
    });
    if (obj.partialBackgrounds) obj.partialBackgrounds.forEach((bg)=>{
        totalBGs.unshift($5e184c6b078bec45$var$getBGObject(bg));
        if (bg.positionDesktop.startsWith("cornerTop") || bg.positionDesktop == "sideTop") collections.desktop.topCorners = true;
        if (bg.positionDesktop.startsWith("cornerBottom") || bg.positionDesktop == "sideBottom") collections.desktop.bottomCorners = true;
        if (bg.positionTablet.startsWith("cornerTop") || bg.positionTablet == "sideTop") collections.tablet.topCorners = true;
        if (bg.positionTablet.startsWith("cornerBottom") || bg.positionTablet == "sideBottom") collections.tablet.bottomCorners = true;
        if (bg.positionMobile.startsWith("cornerTop") || bg.positionMobile == "sideTop") collections.mobile.topCorners = true;
        if (bg.positionMobile.startsWith("cornerBottom") || bg.positionMobile == "sideBottom") collections.mobile.bottomCorners = true;
    });
    const backgroundImage = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            obj.bgColor && "_bfhk9eee",
            !obj.bgColor && "_bfhk1j28",
            obj.textColor && "_syazy0xq",
            !obj.textColor && "_dvo71mpp",
            (hasGradient || obj.bgImage || obj.partialBackgrounds) && "_1itk1svi _12vem49c _1lrwh408 _ouxl1h2r _1l14x2mw _2cw21ntp _1o601bqw _1odri93q",
            collections.mobile.topCorners && "_1q51uuw1",
            collections.mobile.bottomCorners && "_85i5uuw1",
            collections.tablet.topCorners && "_1waf68cl",
            collections.tablet.bottomCorners && "_1yd368cl",
            collections.desktop.topCorners && "_h14068cl",
            collections.desktop.bottomCorners && "_1rgh68cl",
            "styled-background"
        ]),
        style: {
            "--_1j0zdu3": (0, $6ZVlx.default)(obj.bgColor),
            "--_xtedcl": (0, $6ZVlx.default)(obj.textColor),
            "--_1rxcoa2": (0, $6ZVlx.default)(totalBGs.map((__cmplp)=>__cmplp.src).join(", ")),
            "--_g1sd1f": (0, $6ZVlx.default)(totalBGs.map(()=>"no-repeat").join(", ")),
            "--_13otiam": (0, $6ZVlx.default)(totalBGs.map((__cmplp)=>__cmplp.sizeMobile).join(", ")),
            "--_4ewux3": (0, $6ZVlx.default)(totalBGs.map((__cmplp)=>__cmplp.posMobile).join(", ")),
            "--_1tw01p1": (0, $6ZVlx.default)(totalBGs.map((__cmplp)=>__cmplp.sizeTablet).join(", ")),
            "--_15mdg0r": (0, $6ZVlx.default)(totalBGs.map((__cmplp)=>__cmplp.posTablet).join(", ")),
            "--_jw8k5i": (0, $6ZVlx.default)(totalBGs.map((__cmplp)=>__cmplp.sizeDesktop).join(", ")),
            "--_1owty5r": (0, $6ZVlx.default)(totalBGs.map((__cmplp)=>__cmplp.posDesktop).join(", "))
        },
        children: obj.children
    });
};

});
parcelRegister("c9xu6", function(module, exports) {
$parcel$export(module.exports, "getGradient", function () { return $1a402daca80fbbf6$export$e14995d3ec1747ee; });
const $1a402daca80fbbf6$export$e14995d3ec1747ee = (angle, color1, color2)=>{
    if (angle && color1 && color2) return `linear-gradient(${angle}deg, ${color1}, ${color2})`;
    return "";
};

});




parcelRegister("kvg9i", function(module, exports) {
$parcel$export(module.exports, "ConfluencePriceFinder", function () { return $82aa4d75759518c1$export$a33aedde1d62b896; });

var $7VQPk = parcelRequire("7VQPk");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $hCc2m = parcelRequire("hCc2m");

var $g9ZvA = parcelRequire("g9ZvA");

var $gIRO7 = parcelRequire("gIRO7");

var $eYlij = parcelRequire("eYlij");

var $koOAf = parcelRequire("koOAf");

var $fFFp6 = parcelRequire("fFFp6");

var $cLbmg = parcelRequire("cLbmg");

var $cOu5a = parcelRequire("cOu5a");

var $fesdZ = parcelRequire("fesdZ");

var $nFBGc = parcelRequire("nFBGc");

var $cgKz4 = parcelRequire("cgKz4");

var $eQdGa = parcelRequire("eQdGa");

var $hUuit = parcelRequire("hUuit");

var $hRBYs = parcelRequire("hRBYs");

var $6EgwO = parcelRequire("6EgwO");

var $gAdOA = parcelRequire("gAdOA");

var $ies49 = parcelRequire("ies49");

var $g1Nmd = parcelRequire("g1Nmd");

var $5CFs0 = parcelRequire("5CFs0");

var $2yu3p = parcelRequire("2yu3p");

var $9Voys = parcelRequire("9Voys");
const $82aa4d75759518c1$export$a33aedde1d62b896 = (props)=>{
    const intl = (0, $8e22h.default)();
    const newTagText = intl.formatMessage({
        id: "ConfluencePricingPage.priceFinder.newTagText",
        defaultMessage: "New"
    });
    const freePlanFeatureMessages = [
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.unlimitedPages.title",
                    defaultMessage: "Unlimited pages"
                }),
                content: (0, $5CFs0.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.unlimitedSpaces.title",
                    defaultMessage: "Unlimited spaces"
                }),
                content: (0, $2yu3p.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.databases.title",
                    defaultMessage: "Organize and connect work with databases"
                }),
                content: (0, $nFBGc.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.templates.title",
                    defaultMessage: "Templates for Marketing, Product, Program Management and more"
                }),
                content: (0, $g1Nmd.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.activeWhiteboards.title",
                    defaultMessage: "Up to 3 active whiteboards per user "
                }),
                content: (0, $koOAf.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.freeAutomationRuleRuns.title",
                    defaultMessage: "10 automation rule runs per month "
                }),
                content: (0, $fesdZ.FreeAutomationRuleRuns)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.supportAppsAndIntegrations",
                    defaultMessage: "Support for apps and integrations"
                }),
                content: (0, $gAdOA.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.supportFromAtlassianCommunity",
                    defaultMessage: "Support from Atlassian Community"
                }),
                content: (0, $ies49.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.features.freeFileStorage",
                defaultMessage: "Up to 2 GB file storage"
            })
        }
    ];
    const standardPlanFeatureMessages = [
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.externalCollaboration.title",
                    defaultMessage: "External collaboration"
                }),
                content: (0, $eQdGa.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.pagePermissions.title",
                    defaultMessage: "Page permissions"
                }),
                content: (0, $hUuit.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.standardAutomationRuleRuns.title",
                    defaultMessage: "100 automation rule runs per month"
                }),
                content: (0, $fesdZ.StandardAutomationRuleRuns)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.features.standardStorage.title",
                defaultMessage: "250 GB of storage"
            })
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.regionalSupport.title",
                    defaultMessage: "9/5 regional support"
                }),
                content: (0, $6EgwO.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.features.standard150000singlesSite.title",
                defaultMessage: "Up to 150,000 users on a single site"
            })
        }
    ];
    const premiumPlanFeatureMessages = [
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.aiPowered.title",
                    defaultMessage: "AI-powered creation and collaboration"
                }),
                content: (0, $cLbmg.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.dynamicIntranet.title",
                    defaultMessage: "Dynamic intranet"
                }),
                content: (0, $cgKz4.default)
            },
            lozengeText: newTagText
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.perUserAutomation.title",
                    defaultMessage: "Per user automation limits (1000 per month)"
                }),
                content: (0, $cOu5a.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.unlimitedWhiteboards.title",
                    defaultMessage: "Unlimited whiteboards"
                }),
                content: (0, $9Voys.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.adminControlsInsights.title",
                    defaultMessage: "Admin controls and insights"
                }),
                content: (0, $fFFp6.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.features.unlimitedStorage.title",
                defaultMessage: "Unlimited storage"
            })
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.premiumSupport.title",
                    defaultMessage: "24/7 support for critical issues"
                }),
                content: (0, $hRBYs.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.features.premiumSla.title",
                defaultMessage: "99.9% uptime SLA"
            })
        }
    ];
    const confluenceProductPlans = [
        {
            planName: "Free",
            offeringSku: "confluence-free",
            description: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.priceFinder.freeDescription",
                defaultMessage: "Free forever for 10 users"
            }),
            recommendationLimit: 0,
            signupLimit: 150000,
            signupURLSuffix: "?bundle=confluence&edition=free&signupSource=pricing",
            planFeatureMessages: freePlanFeatureMessages
        },
        {
            planName: "Standard",
            offeringSku: "confluence-standard",
            description: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.priceFinder.standardDescription",
                defaultMessage: "Everything you need to get started"
            }),
            recommendationLimit: 10,
            signupLimit: 150000,
            signupURLSuffix: "?bundle=confluence&edition=standard",
            planFeatureMessages: standardPlanFeatureMessages
        },
        {
            planName: "Premium",
            offeringSku: "confluence-premium",
            description: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.priceFinder.premiumDescription",
                defaultMessage: "Connect work across teams"
            }),
            recommendationLimit: 250,
            signupLimit: 150000,
            signupURLSuffix: "?bundle=confluence&edition=premium",
            planFeatureMessages: premiumPlanFeatureMessages
        }
    ];
    const messages = (0, $fnHPc.defineMessages)({
        headerText: {
            id: "ConfluencePricingPageTeam24.priceFinder.headerText",
            defaultMessage: "Build Your <blue>Source of Truth</blue>"
        },
        unitCountInputTextRedesign: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        unitCountInputDirectBuy: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputDirectBuy",
            defaultMessage: "What's your team size?"
        },
        unitCountInputTerm: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputTerm",
            defaultMessage: "users"
        },
        billingCycleText: {
            id: "ConfluencePricingPage.priceFinder.billingCycleText",
            defaultMessage: "Billing cycle:"
        },
        unitCountInputText: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputText",
            defaultMessage: "How many users are on your team?"
        },
        unitCountInputTooltip: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputTooltip",
            defaultMessage: "A Confluence user is any user who can log in to Confluence, and who exists in User Management"
        },
        monthlyExampleHelpText: {
            id: "ConfluencePricingPage.priceFinder.monthlyExampleHelpText",
            defaultMessage: "Monthly plans give you flexibility as your number of active users changes, so pay for seats as you use them. Remember that the number of seats may change the total price."
        },
        annualExampleHelpText: {
            id: "ConfluencePricingPage.priceFinder.annualExampleHelpText",
            defaultMessage: "Annual plans give you flexibility and help you prepare for growth. Buy a group of seats at a flat rate now, then fill your empty seats through the year at no extra cost."
        },
        exampleStandardPlan: {
            id: "ConfluencePricingPage.priceFinder.exampleStandardPlan",
            defaultMessage: "Pricing for {unitCount} users on Standard plan",
            description: "Standard is a plan name and should not be translated"
        },
        cardOverSignupLimit: {
            id: "ConfluencePricingPage.priceFinder.cardOverSignupLimit",
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: "ConfluencePricingPage.priceFinder.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardUnitCountTierRange: {
            id: "ConfluencePricingPage.priceFinder.cardUnitCountTierRange",
            defaultMessage: "User tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "ConfluencePricingPageTeam24.priceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per user / month"
        },
        cardFreeDescription: {
            id: "ConfluencePricingPage.priceFinder.cardFreeDescription",
            defaultMessage: "Always free for 10 users"
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hCc2m.default), {
        interactionName: "conf-price-finder",
        fallback: (0, $g9ZvA.LoadingSpinner),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eYlij.PriceFinderContextProvider), {
            dataProductKey: "confluence",
            productPlans: confluenceProductPlans,
            defaultUnitCount: 150,
            shouldAddDiscount: props.shouldAddDiscount,
            ctaUrlSource: "productPlans",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gIRO7.default), {
                messages: messages,
                serverSideCCPPricing: props.pricing?.ccpPricingData?.confluence,
                countryCode: props.countryCode
            })
        })
    });
};
$82aa4d75759518c1$export$a33aedde1d62b896.displayName = "ConfluencePriceFinder";
var $82aa4d75759518c1$export$2e2bcd8739ae039 = $82aa4d75759518c1$export$a33aedde1d62b896;

});
parcelRegister("koOAf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f16e3c3feb0f7500$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $jQ0cd = parcelRequire("jQ0cd");

var $iRMRa = parcelRequire("iRMRa");
const $f16e3c3feb0f7500$var$ActiveWhiteboards = ()=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)("/software/confluence/whiteboards");
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.activeWhiteboards.content.body",
                defaultMessage: "Confluence whiteboards brings the flexibility of a digital whiteboard into your team workspace. Collaborate, brainstorm, draw and visualize ideas in a freeform way with up to 3 active whiteboards per user. <a>Learn more.</a>",
                values: {
                    ...(0, $iRMRa.DEFAULT_VALUES),
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "learn more",
                            "data-track-event": "ConfluencePricingPageTeam24.activeWhiteboards.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: localizedHref,
                            children: chunks
                        })
                }
            })
        })
    });
};
var $f16e3c3feb0f7500$export$2e2bcd8739ae039 = $f16e3c3feb0f7500$var$ActiveWhiteboards;

});

parcelRegister("fFFp6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $469172ebba1ea1c7$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $469172ebba1ea1c7$var$AdminControlsInsights = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.adminControlsInsights.content.body",
                defaultMessage: "Inspect permissions to specify who can do and create what, and fix permission problems quickly with an admin key. Manage site health, get actionable alerts, and unlock site-level insights, all in one place."
            })
        })
    });
};
var $469172ebba1ea1c7$export$2e2bcd8739ae039 = $469172ebba1ea1c7$var$AdminControlsInsights;

});

parcelRegister("cLbmg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4433695e8f3d4b1b$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $3fFrT = parcelRequire("3fFrT");

var $jQ0cd = parcelRequire("jQ0cd");

var $iRMRa = parcelRequire("iRMRa");
const $4433695e8f3d4b1b$var$AtlassianIntelligence = ()=>{
    const localizedHref = `https://support.atlassian.com${(0, $jQ0cd.useLocalizedHref)("/organization-administration/docs/get-started-with-atlassian-intelligence/", {
        supportedLocales: (0, $3fFrT.ATLASSIAN_SUPPORT_CENTER_SUPPORTED_LOCALES)
    })}`;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.atlassianIntelligence.content.body",
                defaultMessage: "Communicate efficiently, glean relevant insights, and work on what matters with AI capabilities. These include AI-powered editing experiences, quick summaries of long pages, and more. <a>Learn more.</a>",
                values: {
                    ...(0, $iRMRa.DEFAULT_VALUES),
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "learn more",
                            "data-track-event": "ConfluencePricingPageTeam24.atlassianInteligence.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: localizedHref,
                            children: chunks
                        })
                }
            })
        })
    });
};
var $4433695e8f3d4b1b$export$2e2bcd8739ae039 = $4433695e8f3d4b1b$var$AtlassianIntelligence;

});

parcelRegister("cOu5a", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ca383066b7aa1366$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $jQ0cd = parcelRequire("jQ0cd");

var $iRMRa = parcelRequire("iRMRa");
const $ca383066b7aa1366$var$PerUserAutomation = ()=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)("/software/confluence/automation");
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.perUserAutomation.content.body",
                defaultMessage: "Save time by automating repetitive, manual tasks to organize and manage content at scale. Get started quickly with out-of-the box templates or build your own powerful, custom rules by using the low-code / no-code rule builder and with AI. With Premium, unlock up to 1,000 automations per user per month. <a>Learn more.</a>",
                values: {
                    ...(0, $iRMRa.DEFAULT_VALUES),
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "learn more",
                            "data-track-event": "ConfluencePricingPageTeam24.perUserAutomation.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: localizedHref,
                            children: chunks
                        })
                }
            })
        })
    });
};
var $ca383066b7aa1366$export$2e2bcd8739ae039 = $ca383066b7aa1366$var$PerUserAutomation;

});

parcelRegister("fesdZ", function(module, exports) {
$parcel$export(module.exports, "FreeAutomationRuleRuns", function () { return $fba808d380f6bdb1$export$cb1c6db7544762b5; });
$parcel$export(module.exports, "StandardAutomationRuleRuns", function () { return $fba808d380f6bdb1$export$6716f876ee5d7d01; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $jQ0cd = parcelRequire("jQ0cd");

var $iRMRa = parcelRequire("iRMRa");
const $fba808d380f6bdb1$export$cb1c6db7544762b5 = ()=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)("/software/confluence/automation");
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.freeAutomationRuleRuns.content.body",
                defaultMessage: "Increase efficiency by replacing manual, time-consuming work with automated processes and workflows. With Free, unlock 10 automation rule runs per instance per month. <a>Learn more.</a>",
                values: {
                    ...(0, $iRMRa.DEFAULT_VALUES),
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "learn more",
                            "data-track-event": "ConfluencePricingPageTeam24.freeAutomationRuleRuns.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: localizedHref,
                            children: chunks
                        })
                }
            })
        })
    });
};
const $fba808d380f6bdb1$export$6716f876ee5d7d01 = ()=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)("/software/confluence/automation");
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.standardAutomationRuleRuns.content.body",
                defaultMessage: "Increase efficiency by replacing manual, time-consuming work with automated processes and workflows. With Standard, unlock 100 automation rule runs per instance per month. <a>Learn more.</a>",
                values: {
                    ...(0, $iRMRa.DEFAULT_VALUES),
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "learn more",
                            "data-track-event": "ConfluencePricingPageTeam24.standardAutomationRuleRuns.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: localizedHref,
                            children: chunks
                        })
                }
            })
        })
    });
};

});

parcelRegister("nFBGc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $508f39883b774a30$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $jQ0cd = parcelRequire("jQ0cd");

var $iRMRa = parcelRequire("iRMRa");

var $dtAYn = parcelRequire("dtAYn");
const $508f39883b774a30$var$Databases = ()=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)("/software/confluence/databases");
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.databases.content.body",
                defaultMessage: "Confluence databases are a central source of info that dramatically changes the way that teams can organize, reference, and display data in Confluence. <a>Learn more</a>.",
                values: {
                    ...(0, $iRMRa.DEFAULT_VALUES),
                    a: (0, $dtAYn.getMessageHyperlinkValue)({
                        localizedHref: localizedHref,
                        "data-event-container": "ConfluencePricingPage",
                        "data-label-english": "Learn more",
                        "data-track-event": "ConfluencePricingPageTeam24.databases"
                    })
                }
            })
        })
    });
};
var $508f39883b774a30$export$2e2bcd8739ae039 = $508f39883b774a30$var$Databases;

});
parcelRegister("dtAYn", function(module, exports) {
$parcel$export(module.exports, "getMessageHyperlinkValue", function () { return $fc23cd4c346f4bb0$export$c5b540569b1a51b0; });

var $7VQPk = parcelRequire("7VQPk");
function $fc23cd4c346f4bb0$export$c5b540569b1a51b0(params) {
    const { localizedHref: localizedHref, ...rest } = params;
    return (chunks)=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            href: params.localizedHref,
            ...rest,
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-product-key": "confluence",
            children: chunks
        });
    };
}

});


parcelRegister("cgKz4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6464191f0fead551$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $jQ0cd = parcelRequire("jQ0cd");

var $iRMRa = parcelRequire("iRMRa");
const $6464191f0fead551$var$DynamicIntranet = ()=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)("/software/confluence/use-cases/intranet-software");
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.dynamicIntranet.content.body",
                defaultMessage: "Customize a dynamic info hub for your entire company with company hub, a single go-to destination for company news, announcements, and resources. <a>Learn more.</a>",
                values: {
                    ...(0, $iRMRa.DEFAULT_VALUES),
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "learn more",
                            "data-track-event": "ConfluencePricingPageTeam24.dynamicIntranet.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: localizedHref,
                            children: chunks
                        })
                }
            })
        })
    });
};
var $6464191f0fead551$export$2e2bcd8739ae039 = $6464191f0fead551$var$DynamicIntranet;

});

parcelRegister("eQdGa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f839d5e47581ebfa$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $f839d5e47581ebfa$var$ExternalCollaboration = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "ConfluencePricingPageTeam24.features.externalCollaboration.content.bodyOne",
                    defaultMessage: "Invite external partners to collaborate as guests in your Confluence site. Guests are free of charge, up to 5 guests per paid user."
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "ConfluencePricingPageTeam24.features.externalCollaboration.content.bodyTwo",
                    defaultMessage: "You can also share view-only Confluence pages via public links. This can be useful for sharing information to the public, like customer FAQs and release notes."
                })
            })
        ]
    });
};
var $f839d5e47581ebfa$export$2e2bcd8739ae039 = $f839d5e47581ebfa$var$ExternalCollaboration;

});

parcelRegister("hUuit", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ef5e90854da8ecb8$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $ef5e90854da8ecb8$var$PagePermissions = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.pagePermissions.content.body",
                defaultMessage: "Control who can view, edit and comment on your pages, so important information can stay restricted until you\u2019re ready to share."
            })
        })
    });
};
var $ef5e90854da8ecb8$export$2e2bcd8739ae039 = $ef5e90854da8ecb8$var$PagePermissions;

});

parcelRegister("hRBYs", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5e1e0d16eb6e1cd0$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $jQ0cd = parcelRequire("jQ0cd");

var $iRMRa = parcelRequire("iRMRa");
const $5e1e0d16eb6e1cd0$var$PremiumSupport = ()=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)("/enterprise/support-services");
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.premiumSupport.content.body",
                defaultMessage: "Get Premium support around the clock from a dedicated team with 1-hour response times to critical issues. <a>Learn more.</a>",
                values: {
                    ...(0, $iRMRa.DEFAULT_VALUES),
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "learn more",
                            "data-track-event": "ConfluencePricingPageTeam24.premiumSupport.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: localizedHref,
                            children: chunks
                        })
                }
            })
        })
    });
};
var $5e1e0d16eb6e1cd0$export$2e2bcd8739ae039 = $5e1e0d16eb6e1cd0$var$PremiumSupport;

});

parcelRegister("6EgwO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1a5d9a10c21c25a8$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $jQ0cd = parcelRequire("jQ0cd");

var $iRMRa = parcelRequire("iRMRa");
const $1a5d9a10c21c25a8$var$RegionalSupport = ()=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)("/enterprise/support-services");
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.regionalSupport.content.body",
                defaultMessage: "Customer support during business hours is available with Confluence Standard plan. <a>Learn more.</a>",
                values: {
                    ...(0, $iRMRa.DEFAULT_VALUES),
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-track-event": "ConfluencePricingPageTeam24.regionalSupport.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            "data-label-english": "learn more",
                            href: localizedHref,
                            children: chunks
                        })
                }
            })
        })
    });
};
var $1a5d9a10c21c25a8$export$2e2bcd8739ae039 = $1a5d9a10c21c25a8$var$RegionalSupport;

});

parcelRegister("gAdOA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f3f831b9287d5da4$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $iRMRa = parcelRequire("iRMRa");
const $f3f831b9287d5da4$var$SupportAppsIntegrations = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.supportAppsIntegrations.content.body",
                defaultMessage: "Integrate Confluence with other apps you\u2019re already using. <a>Learn more.</a>",
                values: {
                    ...(0, $iRMRa.DEFAULT_VALUES),
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "Learn More",
                            "data-track-event": "ConfluencePricingPageTeam24.supportAppsIntegrations.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: "https://marketplace.atlassian.com/search?product=confluence",
                            children: chunks
                        })
                }
            })
        })
    });
};
var $f3f831b9287d5da4$export$2e2bcd8739ae039 = $f3f831b9287d5da4$var$SupportAppsIntegrations;

});

parcelRegister("ies49", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b7b841abdaecb242$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $iRMRa = parcelRequire("iRMRa");
const $b7b841abdaecb242$var$SupportAtlassianCommunity = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.supportAtlassianCommunity.content.body",
                defaultMessage: "Get support from the <a>Atlassian Community</a>, a public forum of community experts where you can ask questions. You can also access free Confluence guides and knowledge base articles.",
                values: {
                    ...(0, $iRMRa.DEFAULT_VALUES),
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-track-event": "ConfluencePricingPageTeam24.supportAtlassianCommunity",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            "data-label-english": "Atlassian Community",
                            href: "https://community.atlassian.com/",
                            children: chunks
                        })
                }
            })
        })
    });
};
var $b7b841abdaecb242$export$2e2bcd8739ae039 = $b7b841abdaecb242$var$SupportAtlassianCommunity;

});

parcelRegister("g1Nmd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d99847d75ead21a0$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $jQ0cd = parcelRequire("jQ0cd");

var $iRMRa = parcelRequire("iRMRa");
const $d99847d75ead21a0$var$Templates = ()=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)("/software/confluence/templates");
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.templates.content.body",
                defaultMessage: "Get started quickly by using the <a>template library</a>. From product requirement documents to marketing plans, there\u2019s a template that\u2019s perfect fit for your project.",
                values: {
                    ...(0, $iRMRa.DEFAULT_VALUES),
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-track-event": "ConfluencePricingPageTeam24.templates",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            "data-label-english": "template libary",
                            href: localizedHref,
                            children: chunks
                        })
                }
            })
        })
    });
};
var $d99847d75ead21a0$export$2e2bcd8739ae039 = $d99847d75ead21a0$var$Templates;

});

parcelRegister("5CFs0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b141362605c57423$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $b141362605c57423$var$UnlimitedPages = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.unlimitedPages.content.body",
                defaultMessage: "Pages are used to create, share, and edit knowledge. These are living documents you can create and update for almost anything \u2013 from project plans, meeting notes, policies and more. You can create as many pages as you need."
            })
        })
    });
};
var $b141362605c57423$export$2e2bcd8739ae039 = $b141362605c57423$var$UnlimitedPages;

});

parcelRegister("2yu3p", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d946899749b1f69d$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $d946899749b1f69d$var$UnlimitedSpaces = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.unlimitedSpaces.content.body",
                defaultMessage: "Spaces are how you organize pages into meaningful categories, like different folders where you can store your work. You can create as many spaces as you need."
            })
        })
    });
};
var $d946899749b1f69d$export$2e2bcd8739ae039 = $d946899749b1f69d$var$UnlimitedSpaces;

});

parcelRegister("9Voys", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a0a4624eaf1e1adf$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $jQ0cd = parcelRequire("jQ0cd");

var $iRMRa = parcelRequire("iRMRa");
const $a0a4624eaf1e1adf$var$UnlimitedWhiteboards = ()=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)("/software/confluence/whiteboards");
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.unlimitedWhiteboards.content.body",
                defaultMessage: "Confluence whiteboards brings the flexibility of a digital whiteboard into your team workspace. With Premium, unlock unlimited whiteboards and advanced Jira integrations to brainstorm, plan and action work like never before. <a>Learn more.</a>",
                values: {
                    ...(0, $iRMRa.DEFAULT_VALUES),
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-track-event": "ConfluencePricingPageTeam24.unlimitedWhiteboards.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            "data-label-english": "learn more",
                            href: localizedHref,
                            children: chunks
                        })
                }
            })
        })
    });
};
var $a0a4624eaf1e1adf$export$2e2bcd8739ae039 = $a0a4624eaf1e1adf$var$UnlimitedWhiteboards;

});


parcelRegister("gaPqz", function(module, exports) {
$parcel$export(module.exports, "JiraPriceFinder", function () { return $47b0960c2ef159b2$export$1bf486cdabb14f4d; });

var $7VQPk = parcelRequire("7VQPk");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $hCc2m = parcelRequire("hCc2m");

var $g9ZvA = parcelRequire("g9ZvA");

var $gIRO7 = parcelRequire("gIRO7");

var $eYlij = parcelRequire("eYlij");

var $1hGR5 = parcelRequire("1hGR5");

var $c6rNV = parcelRequire("c6rNV");

var $8kuWI = parcelRequire("8kuWI");

var $WOC4s = parcelRequire("WOC4s");

var $5Ikga = parcelRequire("5Ikga");

var $83Gke = parcelRequire("83Gke");

var $guvAv = parcelRequire("guvAv");

var $dBwTO = parcelRequire("dBwTO");

var $h2AoW = parcelRequire("h2AoW");

var $17uTl = parcelRequire("17uTl");

var $6w3tN = parcelRequire("6w3tN");

var $8wGxe = parcelRequire("8wGxe");

var $gl8tX = parcelRequire("gl8tX");
const $47b0960c2ef159b2$export$1bf486cdabb14f4d = (props)=>{
    const intl = (0, $8e22h.default)();
    const newTagText = intl.formatMessage({
        id: "JiraSoftwarePricingPage.priceFinder.newTagText",
        defaultMessage: "New"
    });
    const freePlanFeatureMessages = [
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.unlimitedProjectBoards.title.v2",
                    defaultMessage: "Unlimited goals, projects, tasks, and forms"
                }),
                content: (0, $8wGxe.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.backlogAndTimeline.title",
                    defaultMessage: "Backlog, list, board, timeline, calendar, and summary views"
                }),
                content: (0, $8kuWI.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.reportsAndDashboards.title",
                    defaultMessage: "Reports and dashboards"
                }),
                content: (0, $dBwTO.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.freeAutomations.title",
                    defaultMessage: "100 automation rule runs per month"
                }),
                content: (0, $c6rNV.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "JiraSoftwarePricingPage.priceFinder.freePlan2GBOfStorage",
                defaultMessage: "2 GB of storage"
            })
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.freeCommunitySupport.title",
                    defaultMessage: "Support from Atlassian Community"
                }),
                content: (0, $h2AoW.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "JiraSoftwarePricingPageV2.features.upTo10Users.title",
                defaultMessage: "Up to 10 users"
            })
        }
    ];
    const standardPlanFeatureMessages = [
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.userRolesPermissions.title",
                    defaultMessage: "User roles and permissions"
                }),
                content: (0, $gl8tX.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.externalCollaboration.title",
                    defaultMessage: "External collaboration"
                }),
                content: (0, $83Gke.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.multiRegionDataResidency.title",
                    defaultMessage: "Multi-region data residency"
                }),
                content: (0, $guvAv.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.standardAutomations.title",
                    defaultMessage: "1,700 automation rule runs per month"
                }),
                content: (0, $c6rNV.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "JiraSoftwarePricingPageV2.features.standardStorage.title",
                defaultMessage: "250 GB of storage"
            })
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.standardSupport.title",
                    defaultMessage: "9/5 regional support"
                }),
                content: (0, $6w3tN.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "JiraSoftwarePricingPageV2.features.standard5000singlesSite.title",
                defaultMessage: "Up to 100,000 users on a single site"
            })
        }
    ];
    const premiumPlanFeatureMessages = [
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.aiPowered.title.v2",
                    defaultMessage: "Generate, summarize, and search content with Atlassian Intelligence (AI)"
                }),
                content: (0, $1hGR5.default)
            },
            lozengeText: newTagText
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.crossTeamPlanning.title",
                    defaultMessage: "Cross-team planning and dependency management"
                }),
                content: (0, $WOC4s.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.customizableApprovalProcesses.title",
                    defaultMessage: "Customizable approval processes"
                }),
                content: (0, $5Ikga.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.premiumAutomation.title",
                    defaultMessage: "Per user automation limits (1,000 rule runs per month)"
                }),
                content: (0, $c6rNV.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "JiraSoftwarePricingPageV2.features.unlimitedStorage.title",
                defaultMessage: "Unlimited storage"
            })
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.premiumSupport.title",
                    defaultMessage: "24/7 support for critical issues"
                }),
                content: (0, $17uTl.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "JiraSoftwarePricingPageV2.features.premiumSla.title",
                defaultMessage: "99.9% uptime SLA"
            })
        }
    ];
    const signupLimit = 100000;
    // planNames should not be translated
    const jswProductPlans = [
        {
            planName: "Free",
            offeringSku: "jira-software-free",
            description: intl.formatMessage({
                id: "JiraSoftwarePricingPageV2.priceFinder.freeDescription",
                defaultMessage: "Free forever for 10 users"
            }),
            recommendationLimit: 0,
            signupLimit: signupLimit,
            signupURLSuffix: "?bundle=jira-software&edition=free",
            planFeatureMessages: freePlanFeatureMessages
        },
        {
            planName: "Standard",
            offeringSku: "jira-software-standard",
            description: intl.formatMessage({
                id: "JiraSoftwarePricingPageV2.priceFinder.standardDescription",
                defaultMessage: "Everything you need to get started"
            }),
            recommendationLimit: 10,
            signupLimit: signupLimit,
            signupURLSuffix: "?bundle=jira-software&edition=standard",
            planFeatureMessages: standardPlanFeatureMessages
        },
        {
            planName: "Premium",
            offeringSku: "jira-software-premium",
            description: intl.formatMessage({
                id: "JiraSoftwarePricingPageV2.priceFinder.premiumDescription",
                defaultMessage: "Align multiple teams"
            }),
            recommendationLimit: 250,
            signupLimit: signupLimit,
            signupURLSuffix: "?bundle=jira-software&edition=premium",
            planFeatureMessages: premiumPlanFeatureMessages
        }
    ];
    const messages = (0, $fnHPc.defineMessages)({
        headerText: {
            id: "JiraSoftwarePricingPageV2.priceFinder.header",
            defaultMessage: "<blue>Simple, transparent pricing</blue> for every team."
        },
        unitCountInputText: {
            id: "JiraSoftwarePricingPage.priceFinder.unitCountInputText",
            defaultMessage: "How many users are on your team?"
        },
        unitCountInputTextRedesign: {
            id: "JiraSoftwarePricingPage.priceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        unitCountInputDirectBuy: {
            id: "JiraSoftwarePricingPage.priceFinder.unitCountInputDirectBuy",
            defaultMessage: "What's your team size?"
        },
        unitCountInputTerm: {
            id: "JiraSoftwarePricingPage.priceFinder.unitCountInputTerm",
            defaultMessage: "users"
        },
        billingCycleText: {
            id: "JiraSoftwarePricingPage.priceFinder.billingCycleText",
            defaultMessage: "Billing cycle:"
        },
        unitCountInputTooltip: {
            id: "JiraSoftwarePricingPage.priceFinder.unitCountInputTooltip",
            defaultMessage: "A Jira Software user is any user who can log in to Jira Software, and who exists in User Management"
        },
        cardOverSignupLimit: {
            id: "JiraSoftwarePricingPage.priceFinder.cardOverSignupLimit",
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: "JiraSoftwarePricingPage.priceFinder.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardUnitCountTierRange: {
            id: "JiraSoftwarePricingPage.priceFinder.cardUnitCountTierRange",
            defaultMessage: "User tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "JiraSoftwarePricingPageV2.priceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per user / month"
        },
        cardFreeDescription: {
            id: "JiraSoftwarePricingPage.priceFinder.cardFreeDescription",
            defaultMessage: "Always free for 10 users"
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hCc2m.default), {
        interactionName: "jira-price-finder",
        fallback: (0, $g9ZvA.LoadingSpinner),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eYlij.PriceFinderContextProvider), {
            productPlans: jswProductPlans,
            dataProductKey: "jiraSoftware",
            defaultUnitCount: 150,
            shouldAddDiscount: props.shouldAddDiscount,
            ctaUrlSource: "productPlans",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gIRO7.default), {
                messages: messages,
                serverSideCCPPricing: props.pricing?.ccpPricingData?.jiraSoftware,
                countryCode: props.countryCode
            })
        })
    });
};
$47b0960c2ef159b2$export$1bf486cdabb14f4d.displayName = "JiraPriceFinder";

});
parcelRegister("1hGR5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $46f8509b6a94140e$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $46f8509b6a94140e$var$AtlassianIntelligence = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.aiPowered.content.body.v2",
                defaultMessage: "Get more done with AI-powered summaries, generative AI editing, and natural language to build automations or search issues."
            })
        })
    });
};
var $46f8509b6a94140e$export$2e2bcd8739ae039 = $46f8509b6a94140e$var$AtlassianIntelligence;

});

parcelRegister("c6rNV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $39cb99e1093c55f5$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $39cb99e1093c55f5$var$Automations = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.automations.content.body",
                defaultMessage: "Increase efficiency by replacing manual, time-consuming work with automated processes and workflows."
            })
        })
    });
};
var $39cb99e1093c55f5$export$2e2bcd8739ae039 = $39cb99e1093c55f5$var$Automations;

});

parcelRegister("8kuWI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3f8a3492cd08aa6a$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $3f8a3492cd08aa6a$var$Backlog = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.backlogAndTimeline.content.body",
                defaultMessage: "Choose from different views to support your way of working."
            })
        })
    });
};
var $3f8a3492cd08aa6a$export$2e2bcd8739ae039 = $3f8a3492cd08aa6a$var$Backlog;

});

parcelRegister("WOC4s", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $87bc63ad3e80b17b$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $87bc63ad3e80b17b$var$CrossTeamPlanning = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.crossTeamPlanning.content.body",
                defaultMessage: "Plan and track goals, projects, and dependencies in one place."
            })
        })
    });
};
var $87bc63ad3e80b17b$export$2e2bcd8739ae039 = $87bc63ad3e80b17b$var$CrossTeamPlanning;

});

parcelRegister("5Ikga", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $20b6930dc723bc10$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $20b6930dc723bc10$var$CustomizableApprovalProcesses = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.customizableApprovalProcesses.content.body",
                defaultMessage: "Add approval steps to your workflows to get required signoffs."
            })
        })
    });
};
var $20b6930dc723bc10$export$2e2bcd8739ae039 = $20b6930dc723bc10$var$CustomizableApprovalProcesses;

});

parcelRegister("83Gke", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $90529a5f0f2d90d2$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $90529a5f0f2d90d2$var$ExternalCollaboration = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.externalCollaboration.content.body",
                defaultMessage: "Give people outside your org anonymous access to Jira projects."
            })
        })
    });
};
var $90529a5f0f2d90d2$export$2e2bcd8739ae039 = $90529a5f0f2d90d2$var$ExternalCollaboration;

});

parcelRegister("guvAv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b27ff3bd95e80201$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $b27ff3bd95e80201$var$MultiRegionDataResidency = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.multiRegionDataResidency.content.body",
                defaultMessage: "Specify where your content and data are hosted."
            })
        })
    });
};
var $b27ff3bd95e80201$export$2e2bcd8739ae039 = $b27ff3bd95e80201$var$MultiRegionDataResidency;

});

parcelRegister("dBwTO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5e502c2ad812b693$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $5e502c2ad812b693$var$ReportsAndDashboards = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.reportsAndDashboards.content.body",
                defaultMessage: "Get insights on teamwork tracked in any Jira product or project."
            })
        })
    });
};
var $5e502c2ad812b693$export$2e2bcd8739ae039 = $5e502c2ad812b693$var$ReportsAndDashboards;

});

parcelRegister("h2AoW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $305cb22209277d1b$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $305cb22209277d1b$var$CommunitySupport = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.freeCommunitySupport.content.body",
                defaultMessage: "Find answers and support from other Atlassian users."
            })
        })
    });
};
var $305cb22209277d1b$export$2e2bcd8739ae039 = $305cb22209277d1b$var$CommunitySupport;

});

parcelRegister("17uTl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5b772800e5f3090e$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $5b772800e5f3090e$var$PremiumSupport = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.premiumSupport.content.body",
                defaultMessage: "1-hr response time for critical issues from Cloud support team."
            })
        })
    });
};
var $5b772800e5f3090e$export$2e2bcd8739ae039 = $5b772800e5f3090e$var$PremiumSupport;

});

parcelRegister("6w3tN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f3c08a3cece63621$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $f3c08a3cece63621$var$StandardSupport = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.standardSupport.content.body",
                defaultMessage: "2-hr response time for critical issues from Cloud support team."
            })
        })
    });
};
var $f3c08a3cece63621$export$2e2bcd8739ae039 = $f3c08a3cece63621$var$StandardSupport;

});

parcelRegister("8wGxe", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d1cd49baf85eeb35$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $d1cd49baf85eeb35$var$UnlimitedProjects = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.unlimitedProjectBoards.content.body.v2",
                defaultMessage: "Align projects and tasks to goals. Collect data with forms."
            })
        })
    });
};
var $d1cd49baf85eeb35$export$2e2bcd8739ae039 = $d1cd49baf85eeb35$var$UnlimitedProjects;

});

parcelRegister("gl8tX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3027e47bf2c5ff81$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $3027e47bf2c5ff81$var$UserRolesPermissions = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.userRolesPermissions.content.body",
                defaultMessage: "Control what users can create, view, and comment on in Jira."
            })
        })
    });
};
var $3027e47bf2c5ff81$export$2e2bcd8739ae039 = $3027e47bf2c5ff81$var$UserRolesPermissions;

});


parcelRegister("btggB", function(module, exports) {
$parcel$export(module.exports, "getIsGwp10027NonprofitPricingPage", function () { return $6f8d41d4f75a0ee9$export$5669cf21cf977647; });

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
function $6f8d41d4f75a0ee9$export$5669cf21cf977647() {
    return (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp10027NonprofitPricingPage);
}

});

parcelRegister("vCUGX", function(module, exports) {
$parcel$export(module.exports, "NonProfitPricingPageTemplateWithTwc", function () { return $e7c6a76c0fc10e33$export$1e29151fb1d7b783; });

var $7VQPk = parcelRequire("7VQPk");

var $dl2JF = parcelRequire("dl2JF");

var $bE8d4 = parcelRequire("bE8d4");

var $grcEk = parcelRequire("grcEk");

var $kbpa7 = parcelRequire("kbpa7");

var $5S2vX = parcelRequire("5S2vX");

var $iTSLe = parcelRequire("iTSLe");

var $g7wmQ = parcelRequire("g7wmQ");

var $fZJZd = parcelRequire("fZJZd");

var $4bEWc = parcelRequire("4bEWc");

var $71t0B = parcelRequire("71t0B");

var $gtK7Z = parcelRequire("gtK7Z");

var $k53CY = parcelRequire("k53CY");

var $lSpoK = parcelRequire("lSpoK");

var $hJy82 = parcelRequire("hJy82");

var $3icmm = parcelRequire("3icmm");
const $e7c6a76c0fc10e33$export$1e29151fb1d7b783 = ()=>{
    const content = (0, $dl2JF.usePricingContentContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
            pageId: "nonprofit-pricing-page",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    nav: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lSpoK.NonprofitNav), {}),
                    banner: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g7wmQ.Banner), {}),
                    hero: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gtK7Z.Hero), {}),
                    hasGlobalFooter: false
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    bgColor: (0, $kbpa7.wacToken)("color.neutral.light100"),
                    hasGlobalFooter: false,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fZJZd.EligibleSection), {})
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    hasGlobalFooter: false,
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k53CY.NonprofitCalculatorHeading), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iTSLe.NonProfitPricingCalculator), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4bEWc.EnterpriseSection), {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    bgColor: (0, $kbpa7.wacToken)("color.extended.blue100"),
                    hasGlobalFooter: false,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hJy82.OfficialSection), {})
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    hasGlobalFooter: false,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3icmm.ResourcesSection), {})
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    hasGlobalFooter: true,
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bE8d4.PricingFaq), {
                                header: content?.getMoreDetailsTitle,
                                planDetails: content?.additionalDetails
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $71t0B.Fineprint), {})
                        ]
                    })
                })
            ]
        })
    });
};

});
parcelRegister("iTSLe", function(module, exports) {
$parcel$export(module.exports, "NonProfitPricingCalculator", function () { return $21cae14a7b90ea83$export$5866e8a6e62a7e05; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $9RHgs = parcelRequire("9RHgs");

var $42V1t = parcelRequire("42V1t");

var $5TIjy = parcelRequire("5TIjy");

var $aT8t4 = parcelRequire("aT8t4");

var $fNAVV = parcelRequire("fNAVV");

var $437NE = parcelRequire("437NE");
const $21cae14a7b90ea83$var$DEFAULT_UNIT_COUNT = 25;
const $21cae14a7b90ea83$var$DEFAULT_BILLING_CYCLE = "ANNUAL";
const $21cae14a7b90ea83$var$FULL_DISCOUNT_MAX_UNITS = 25;
const $21cae14a7b90ea83$export$5866e8a6e62a7e05 = ()=>{
    const { plansDataByProduct: plansDataByProduct, error: error } = (0, $437NE.useNonProfitPricingCalculatorData)();
    const [inputs, setInputs] = (0, $1oC0p.useState)({
        unitCount: $21cae14a7b90ea83$var$DEFAULT_UNIT_COUNT,
        billingCycle: $21cae14a7b90ea83$var$DEFAULT_BILLING_CYCLE
    });
    const getDiscountedPrice = (0, $1oC0p.useCallback)((args)=>{
        const { price: price, inputs: inputs } = args;
        if (inputs.billingCycle === "ANNUAL" && inputs.unitCount <= $21cae14a7b90ea83$var$FULL_DISCOUNT_MAX_UNITS) return 0;
        return price * 0.25;
    }, []);
    const intl = (0, $8e22h.default)();
    if (error) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $42V1t.ErrorMessage), {});
    if (!plansDataByProduct) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5TIjy.LoadingSpinner), {});
    const fullDiscountBanner = intl.formatMessage({
        id: "nonprofit.fullDiscountBanner",
        defaultMessage: "Showing 100% off"
    });
    const partialDiscountBanner = intl.formatMessage({
        id: "nonprofit.partialDiscountBanner",
        defaultMessage: "Showing 75% off"
    });
    const partialDiscountWithPromptBanner = intl.formatMessage({
        id: "nonprofit.partialDiscountWithPromptBanner",
        defaultMessage: "Showing 75% off - choose Annual billing for 100% off"
    });
    let banner = partialDiscountBanner;
    if (inputs.billingCycle === "ANNUAL" && inputs.unitCount <= $21cae14a7b90ea83$var$FULL_DISCOUNT_MAX_UNITS) banner = fullDiscountBanner;
    if (inputs.billingCycle === "MONTHLY") banner = partialDiscountWithPromptBanner;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9RHgs.PricingTabs), {
        banner: banner,
        jiraCalculatorComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aT8t4.default), {
            comparePlansData: plansDataByProduct[(0, $fNAVV.pricingTitleInternal).JIRA] ?? [],
            urlSlug: "jira",
            inputs: inputs,
            onChangeInputs: setInputs,
            getDiscountedPrice: getDiscountedPrice
        }),
        confluenceCalculatorComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aT8t4.default), {
            comparePlansData: plansDataByProduct[(0, $fNAVV.pricingTitleInternal).CONFLUENCE] ?? [],
            urlSlug: "confluence",
            inputs: inputs,
            onChangeInputs: setInputs,
            getDiscountedPrice: getDiscountedPrice
        }),
        teamworkCollectionComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aT8t4.default), {
            comparePlansData: plansDataByProduct[(0, $fNAVV.pricingTitleInternal).TWC] ?? [],
            urlSlug: "teamwork",
            inputs: inputs,
            onChangeInputs: setInputs,
            getDiscountedPrice: getDiscountedPrice
        }),
        loomCalculatorComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aT8t4.default), {
            comparePlansData: plansDataByProduct[(0, $fNAVV.pricingTitleInternal).LOOM] ?? [],
            urlSlug: "loom",
            inputs: inputs,
            onChangeInputs: setInputs,
            getDiscountedPrice: getDiscountedPrice
        })
    });
};

});
parcelRegister("42V1t", function(module, exports) {
$parcel$export(module.exports, "ErrorMessage", function () { return $92139e655263218b$export$915e9e7bd4f0f96d; });
/* error-message.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");
const $92139e655263218b$export$915e9e7bd4f0f96d = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _4t3i1ogm _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            role: "alert",
            "aria-label": intl.formatMessage({
                id: "pricing-calculator.error",
                defaultMessage: "Error"
            }),
            "data-testid": "global-nav-user-profile-container-spinner",
            children: "ERROR"
        })
    });
};

});

parcelRegister("fNAVV", function(module, exports) {
$parcel$export(module.exports, "pricingTitleInternal", function () { return $7e2f802cabb58fc1$export$e1fb2a6f4d847984; });
$parcel$export(module.exports, "getNonprofitPricingCalculatorData", function () { return $7e2f802cabb58fc1$export$3d0bcdd9a87aae52; });

var $g0Z8A = parcelRequire("g0Z8A");

var $29JVp = parcelRequire("29JVp");

var $j1ORI = parcelRequire("j1ORI");

var $4utnL = parcelRequire("4utnL");

var $YmHME = parcelRequire("YmHME");
const $7e2f802cabb58fc1$export$e1fb2a6f4d847984 = {
    JIRA: "Jira Pricing Page",
    CONFLUENCE: "Confluence Pricing Page",
    TWC: "Teamwork Collection Pricing Page",
    LOOM: "Loom Pricing Page"
};
const $7e2f802cabb58fc1$export$3d0bcdd9a87aae52 = async ()=>{
    const result = await (0, $g0Z8A.getPricingCalculatorData)([
        $7e2f802cabb58fc1$export$e1fb2a6f4d847984.JIRA,
        $7e2f802cabb58fc1$export$e1fb2a6f4d847984.CONFLUENCE,
        $7e2f802cabb58fc1$export$e1fb2a6f4d847984.TWC,
        $7e2f802cabb58fc1$export$e1fb2a6f4d847984.LOOM
    ]);
    return $7e2f802cabb58fc1$var$omitEnterprisePlans(result);
};
const $7e2f802cabb58fc1$var$omitEnterprisePlans = (plansDataByProduct)=>{
    const jiraPlans = plansDataByProduct[$7e2f802cabb58fc1$export$e1fb2a6f4d847984.JIRA]?.filter((plan)=>{
        const sku = plan.pricingPlan?.sku;
        return sku !== (0, $j1ORI.jiraOfferingSkus).enterprise;
    }) ?? [];
    const confluencePlans = plansDataByProduct[$7e2f802cabb58fc1$export$e1fb2a6f4d847984.CONFLUENCE]?.filter((plan)=>{
        const sku = plan.pricingPlan?.sku;
        return sku !== (0, $29JVp.confluenceOfferingSkus).enterprise;
    }) ?? [];
    const teamworkCollectionPlans = plansDataByProduct[$7e2f802cabb58fc1$export$e1fb2a6f4d847984.TWC]?.filter((plan)=>{
        const sku = plan.pricingPlan?.sku;
        return sku !== (0, $YmHME.teamworkCollectionOfferingSkus).enterprise;
    }) ?? [];
    const loomPlans = plansDataByProduct[$7e2f802cabb58fc1$export$e1fb2a6f4d847984.LOOM]?.filter((plan)=>{
        const sku = plan.pricingPlan?.sku;
        return sku !== (0, $4utnL.loomOfferingSkus).enterprise;
    }) ?? [];
    return {
        [$7e2f802cabb58fc1$export$e1fb2a6f4d847984.JIRA]: jiraPlans,
        [$7e2f802cabb58fc1$export$e1fb2a6f4d847984.CONFLUENCE]: confluencePlans,
        [$7e2f802cabb58fc1$export$e1fb2a6f4d847984.TWC]: teamworkCollectionPlans,
        [$7e2f802cabb58fc1$export$e1fb2a6f4d847984.LOOM]: loomPlans
    };
};

});
parcelRegister("g0Z8A", function(module, exports) {
$parcel$export(module.exports, "getPricingCalculatorData", function () { return $bfe47c5595fb2c89$export$ec56dd3792d0c55e; });

var $61WdP = parcelRequire("61WdP");
async function $bfe47c5595fb2c89$export$ec56dd3792d0c55e(pricingTitleInternals) {
    const contentClient = await (0, $61WdP.getContentfulContentClient)();
    const contentResult = await contentClient.getEntries({
        "content_type": "pricing",
        "fields.pricingTitleInternal[in]": pricingTitleInternals,
        "select": [
            "sys",
            "fields.comparePlans",
            "fields.pricingTitleInternal",
            "fields.compareFeaturesTitle"
        ],
        "include": 10
    });
    const productCatalogClient = (0, $61WdP.getContentfulProductCatalogClient)();
    const productCatalogResults = await Promise.all(contentResult.items.map((item)=>{
        const skus = item.fields.comparePlans.map((plan)=>plan.fields.sku);
        return productCatalogClient.getCCPPricingData(skus);
    }));
    const ccpPricingData = productCatalogResults.reduce((acc, result)=>{
        return {
            ...acc,
            ...result
        };
    }, {});
    return pricingTitleInternals.reduce((acc, pricingTitleInternal)=>{
        const product = contentResult.items.find((product)=>product.fields.pricingTitleInternal === pricingTitleInternal);
        const comparePlans = product?.fields.comparePlans;
        if (!comparePlans) return acc;
        acc[pricingTitleInternal] = comparePlans.map((plan)=>({
                ...plan,
                pricingPlan: ccpPricingData[plan.fields.sku]
            })) ?? [];
        return acc;
    }, {});
}

});
parcelRegister("61WdP", function(module, exports) {
$parcel$export(module.exports, "getContentfulContentClient", function () { return $c51fe70e32d8081e$export$5aaa8f1b0d95285f; });
$parcel$export(module.exports, "getContentfulProductCatalogClient", function () { return $c51fe70e32d8081e$export$c784e669eb2d0fdf; });

var $dkcYJ = parcelRequire("dkcYJ");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $eRzlV = parcelRequire("eRzlV");
const $c51fe70e32d8081e$export$fb1a35d5fe33878b = "nDQjfHDrrDfmPuccfIHYNMU3pSNCi1WOTRsI-q0igVU";
const $c51fe70e32d8081e$export$6fea527509143071 = "3s3v3nq72la0";
const $c51fe70e32d8081e$var$PRODUCT_TEMPLATES_ENVIRONMENT = "master";
const $c51fe70e32d8081e$var$PRODUCT_TEMPLATES_DELIVERY_KEY = "fTu2YoVb3vqTOyvfOZveEriN4V4vgNk9aVYcJuLRfc8";

const $c51fe70e32d8081e$export$5aaa8f1b0d95285f = async ()=>{
    const { createClient: createClient } = await (parcelRequire("2oGlC"));
    return createClient({
        space: "xjcz23wx147q",
        environment: $c51fe70e32d8081e$var$PRODUCT_TEMPLATES_ENVIRONMENT,
        accessToken: String($c51fe70e32d8081e$var$PRODUCT_TEMPLATES_DELIVERY_KEY)
    });
};
const $c51fe70e32d8081e$export$c784e669eb2d0fdf = ()=>{
    const productCatalogEnvironment = $c51fe70e32d8081e$var$getContentfulProductCatalogEnvironment();
    return new (0, $dkcYJ.ProductCatalogClient)(String($c51fe70e32d8081e$export$fb1a35d5fe33878b), String($c51fe70e32d8081e$export$6fea527509143071), productCatalogEnvironment);
};
const $c51fe70e32d8081e$var$getContentfulProductCatalogEnvironment = ()=>{
    if ((0, $eRzlV.isProduction)()) return "master";
    const isCcpStaging = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp9034WacPricingCcpStaging);
    return isCcpStaging ? "ccp_staging" : "master";
};

});
parcelRegister("dkcYJ", function(module, exports) {
$parcel$export(module.exports, "ProductCatalogClient", function () { return $44efc64b5afbeaf3$export$103ea0adeef74210; });
$parcel$export(module.exports, "useCCPPriceFinderData", function () { return $44efc64b5afbeaf3$export$cd96e69292b0829; });
$parcel$export(module.exports, "useHAMSPriceData", function () { return $44efc64b5afbeaf3$export$487b53c25dfbddc8; });

var $g7Jsj = parcelRequire("g7Jsj");

var $1oC0p = parcelRequire("1oC0p");

var $hrGO1 = parcelRequire("hrGO1");
var $44efc64b5afbeaf3$var$EDITION_SUFFIXES = /*#__PURE__*/ function(EDITION_SUFFIXES) {
    EDITION_SUFFIXES["FREE"] = ".free";
    EDITION_SUFFIXES["STANDARD"] = "";
    EDITION_SUFFIXES["PREMIUM"] = ".premium";
    EDITION_SUFFIXES["ENTERPRISE"] = ".enterprise";
    return EDITION_SUFFIXES;
}($44efc64b5afbeaf3$var$EDITION_SUFFIXES || {});
const $44efc64b5afbeaf3$var$NON_STANDARD_EDITION_SUFFIXES = [
    ".free",
    ".premium",
    ".enterprise"
];
class $44efc64b5afbeaf3$export$103ea0adeef74210 {
    constructor(accessToken, space, environment = "master"){
        this.accessToken = accessToken;
        this.space = space;
        this.environment = environment;
    }
    getUrl() {
        return `https://cdn.contentful.com/spaces/${this.space}/environments/${this.environment}`;
    }
    async getEntries(queryParams) {
        const url = this.getUrl();
        const response = await fetch(`${url}/entries?access_token=${this.accessToken}&${queryParams}`);
        if (response.ok) return response.json();
        throw new (0, $g7Jsj.UnsuccessfulFetchError)({
            message: "Unable to fetch prices",
            response: response
        });
    }
    /**
   *
   * @param key the `key` property of the HAMS Product
   * @returns Monthly prices for each headcount bucket for the free, standard and premium tiers
   */ //TODO: Update to accept CCP Offering Sku
    async getLocalizedPriceBlockPrices(key) {
        const pricingQuery = `content_type=product&select=fields.key%2Cfields.defaultStdPricingPlanMonthly%2Cfields.defaultPremiumPricingPlanMonthly%2Cfields.defaultFreePricingPlanMonthly%2Cfields.defaultEnterprisePricingPlanMonthly%2Csys.id%2Csys.type&fields.key%5Bin%5D=${key}&include=2`;
        const { includes: includes, items: items } = await this.getEntries(pricingQuery);
        if (!items.length) throw new Error("No pricing plans match this key");
        const parentPricingPlan = items[0];
        const freeMonthly = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultFreePricingPlanMonthly?.sys.id);
        const standardMonthly = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultStdPricingPlanMonthly?.sys.id);
        const premiumMonthly = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultPremiumPricingPlanMonthly?.sys.id);
        return {
            free: freeMonthly?.fields.configuration,
            standard: standardMonthly?.fields.configuration,
            premium: premiumMonthly?.fields.configuration
        };
    }
    async getLocalizedPriceBlockDropdown(key) {
        const pricingQuery = `content_type=product&select=fields.key%2Cfields.defaultStdPricingPlanMonthly%2Cfields.defaultStdPricingPlanYearly%2Cfields.defaultPremiumPricingPlanMonthly%2Cfields.defaultPremiumPricingPlanYearly%2Cfields.defaultFreePricingPlanMonthly%2Cfields.defaultEnterprisePricingPlanMonthly%2Cfields.defaultEnterprisePricingPlanYearly%2Csys.id%2Csys.type&fields.key%5Bin%5D=${key}`;
        const { includes: includes, items: items } = await this.getEntries(pricingQuery);
        if (!items.length || !includes) throw new Error("No pricing plans match this key");
        const fields = includes.Entry[0]?.fields.configuration;
        return fields;
    }
    /**
   *
   * @param key the `key` property of the HAMS Product
   * @returns Monthly prices for each headcount bucket for the free, standard and premium tiers
   */ async getHAMSPrices(key) {
        const pricingQuery = `content_type=product&select=fields.key%2Cfields.defaultStdPricingPlanMonthly%2Cfields.defaultStdPricingPlanYearly%2Cfields.defaultPremiumPricingPlanMonthly%2Cfields.defaultPremiumPricingPlanYearly%2Cfields.defaultFreePricingPlanMonthly%2Cfields.defaultEnterprisePricingPlanMonthly%2Cfields.defaultEnterprisePricingPlanYearly%2Csys.id%2Csys.type&fields.key%5Bin%5D=${key}`;
        const { includes: includes, items: items } = await this.getEntries(pricingQuery);
        if (!items.length) throw new Error(`No HAMS plans match this key: ${key}`);
        const productKeys = [
            key + ".free",
            key,
            key + ".premium",
            key + ".enterprise"
        ];
        const removeEditionSuffix = (productKey)=>productKey.replace(new RegExp($44efc64b5afbeaf3$var$NON_STANDARD_EDITION_SUFFIXES.map((suffix)=>`\\${suffix}`).join("|") + "$"), "");
        const getPricingPlansForEditionSuffixedKey = (editionSuffixedProductKey)=>{
            const matchedEditionSuffix = $44efc64b5afbeaf3$var$NON_STANDARD_EDITION_SUFFIXES.reduce((matchingEditionSuffix, editionSuffix)=>editionSuffixedProductKey.endsWith(editionSuffix) ? editionSuffix : matchingEditionSuffix, "");
            const parentPricingPlan = items[0];
            const freeMonthly = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultFreePricingPlanMonthly?.sys.id);
            const freeAnnual = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultFreePricingPlanYearly?.sys.id);
            const standardMonthly = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultStdPricingPlanMonthly?.sys.id);
            const premiumMonthly = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultPremiumPricingPlanMonthly?.sys.id);
            const enterpriseMonthly = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultEnterprisePricingPlanMonthly?.sys.id);
            const standardAnnual = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultStdPricingPlanYearly?.sys.id);
            const premiumAnnual = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultPremiumPricingPlanYearly?.sys.id);
            const enterpriseAnnual = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultEnterprisePricingPlanYearly?.sys.id);
            let monthly = undefined;
            let annual = undefined;
            switch(matchedEditionSuffix){
                case ".free":
                    monthly = freeMonthly?.fields.configuration;
                    annual = freeAnnual?.fields.configuration;
                    break;
                case "":
                    monthly = standardMonthly?.fields.configuration;
                    annual = standardAnnual?.fields.configuration;
                    break;
                case ".premium":
                    monthly = premiumMonthly?.fields.configuration;
                    annual = premiumAnnual?.fields.configuration;
                    break;
                case ".enterprise":
                    monthly = enterpriseMonthly?.fields.configuration;
                    annual = enterpriseAnnual?.fields.configuration;
                    break;
            }
            return {
                monthly: monthly?.map($44efc64b5afbeaf3$var$mapPricingPlanToPricingTier),
                annual: annual?.map($44efc64b5afbeaf3$var$mapPricingPlanToPricingTier)
            };
        };
        let ret = {};
        for (const productKey of productKeys){
            const editionlessKey = removeEditionSuffix(productKey);
            const entry = items.find(({ fields: { key: key } })=>key === editionlessKey);
            if (entry) ret = {
                ...ret,
                [productKey]: getPricingPlansForEditionSuffixedKey(productKey)
            };
        }
        return ret;
    }
    /**
   *
   * @param offeringSKUs the `key` property of the CCP Product
   * @returns A map of offeringSkus to their respective product plan content
   */ async getCCPPricingData(offeringSKUs) {
        const mappedOfferings = offeringSKUs.map((offeringSku, idx)=>{
            if (idx > 0) return `%2C${offeringSku}`;
            else return `=${offeringSku}`;
        }).join("");
        const ccpPricingDataQuery = `content_type=31uDFGQ9rMyZpBgP4oexja&fields.sku%5Bin%5D${mappedOfferings}`;
        const { items: items, includes: includes } = await this.getEntries(ccpPricingDataQuery);
        if (!items.length) throw new Error("No offerings match this key");
        const ret = {};
        for (const offeringSKU of offeringSKUs){
            const entry = items.find(({ fields: { sku: sku } })=>sku === offeringSKU);
            const contentfulOffering = entry?.fields;
            const pricingPlans = includes.Entry.map((includedEntry)=>{
                if (includedEntry.fields.offeringName === contentfulOffering?.name) return includedEntry.fields;
                else return undefined;
            }).filter(Boolean);
            contentfulOffering?.defaultPricingPlans?.splice(0, contentfulOffering.defaultPricingPlans.length, ...pricingPlans);
            ret[offeringSKU] = contentfulOffering;
        }
        return ret;
    }
}
function $44efc64b5afbeaf3$export$cd96e69292b0829(offeringSKUs, accessToken, space, environment) {
    const offeringSKUsCount = offeringSKUs.length;
    const [status, setStatus] = (0, $1oC0p.useState)("idle");
    const [prices, setPrices] = (0, $1oC0p.useState)();
    const client = (0, $1oC0p.useRef)(new $44efc64b5afbeaf3$export$103ea0adeef74210(accessToken, space, environment)).current;
    const fetchData = (0, $1oC0p.useCallback)(async ()=>{
        if (offeringSKUsCount) {
            setStatus("fetching");
            const retrievedPrices = await client.getCCPPricingData(offeringSKUs);
            setPrices(retrievedPrices);
            setStatus("complete");
        } else {
            setStatus("complete");
            setPrices({});
        }
    }, [
        offeringSKUsCount
    ]);
    return {
        status: status,
        prices: prices,
        fetchData: fetchData
    };
}
function $44efc64b5afbeaf3$export$487b53c25dfbddc8(key, accessToken, space, environment) {
    const [status, setStatus] = (0, $1oC0p.useState)("idle");
    const [prices, setPrices] = (0, $1oC0p.useState)();
    const client = new $44efc64b5afbeaf3$export$103ea0adeef74210(accessToken, space, environment);
    (0, $1oC0p.useEffect)(()=>{
        const fetchData = async ()=>{
            setStatus("fetching");
            const retrievedPrices = await client.getHAMSPrices(key);
            setPrices(retrievedPrices);
            setStatus("complete");
        };
        if (key) fetchData();
        else {
            setStatus("complete");
            setPrices({});
        }
    }, [
        key
    ]);
    return {
        status: status,
        prices: prices
    };
}
function $44efc64b5afbeaf3$export$cee963e0757fb89b(key, accessToken, space, environment) {
    const [status, setStatus] = (0, $1oC0p.useState)("idle");
    const [prices, setPrices] = (0, $1oC0p.useState)();
    const client = new $44efc64b5afbeaf3$export$103ea0adeef74210(accessToken, space, environment);
    (0, $1oC0p.useEffect)(()=>{
        const fetchData = async ()=>{
            setStatus("fetching");
            const retrievedPrices = await client.getLocalizedPriceBlockPrices(key);
            setPrices(retrievedPrices);
            setStatus("complete");
        };
        fetchData();
    }, []);
    return {
        status: status,
        prices: prices
    };
}
//TODO: Do we need this? Can we just use the types already declared and reuse them?
function $44efc64b5afbeaf3$var$mapPricingPlanToPricingTier({ pricing_strategy: pricing_strategy, unit_description: unit_description, unit_limit_lower: unit_limit_lower, unit_limit_upper: unit_limit_upper, prices: prices }) {
    return {
        pricingStrategy: (0, $hrGO1.parsePricingStrategy)(pricing_strategy),
        unitDescription: unit_description,
        unitLimitLower: unit_limit_lower,
        unitLimitUpper: unit_limit_upper,
        prices: prices.map($44efc64b5afbeaf3$var$mapPricingPlanPricesItemPriceToPricingTierPrice)
    };
}
function $44efc64b5afbeaf3$var$mapPricingPlanPricesItemPriceToPricingTierPrice({ currency: currency, unit_price: unit_price }) {
    return {
        currency: currency,
        unitPrice: unit_price
    };
}
function $44efc64b5afbeaf3$export$9e1397dbc82e4578(key, accessToken, space, environment) {
    const [status, setStatus] = (0, $1oC0p.useState)("idle");
    const [prices, setPrices] = (0, $1oC0p.useState)();
    const client = new $44efc64b5afbeaf3$export$103ea0adeef74210(accessToken, space, environment);
    (0, $1oC0p.useEffect)(()=>{
        const fetchData = async ()=>{
            setStatus("fetching");
            const retrievedPrices = await client.getLocalizedPriceBlockDropdown(key);
            setPrices(retrievedPrices);
            setStatus("complete");
        };
        fetchData();
    }, []);
    return {
        status: status,
        prices: prices
    };
}

});
parcelRegister("hrGO1", function(module, exports) {
$parcel$export(module.exports, "TRACKING_EVENT_NAMES", function () { return $37d29093f218a0c9$export$9a56b303ccc53008; });
$parcel$export(module.exports, "DEFAULT_COUNTRY_ISO_CODE", function () { return $37d29093f218a0c9$export$b1f75679747bdf24; });
$parcel$export(module.exports, "DEFAULT_CURRENCY_ISO_CODE", function () { return $37d29093f218a0c9$export$427ae666c2c86a64; });
$parcel$export(module.exports, "SpecialPlanNames", function () { return $37d29093f218a0c9$export$3f5e519890ec420; });
$parcel$export(module.exports, "CloudOfferingsWithSkus", function () { return $37d29093f218a0c9$export$49640008eae271a8; });
$parcel$export(module.exports, "SpecialProductKeys", function () { return $37d29093f218a0c9$export$9bb4a98475a54313; });
$parcel$export(module.exports, "DefaultPlanLimits", function () { return $37d29093f218a0c9$export$dcfb07a55b760b78; });
$parcel$export(module.exports, "PricingStrategy", function () { return $37d29093f218a0c9$export$d5367d5d99549333; });
$parcel$export(module.exports, "parsePricingStrategy", function () { return $37d29093f218a0c9$export$b136e5eb1cbda98a; });
$parcel$export(module.exports, "TRELLO_CTA_URL", function () { return $37d29093f218a0c9$export$3d9423ec9a4e8352; });
$parcel$export(module.exports, "SIGNUP_CTA_URL", function () { return $37d29093f218a0c9$export$3c460f2e36dca740; });
$parcel$export(module.exports, "CONTACT_CTA_URL", function () { return $37d29093f218a0c9$export$cee779d81c7e245b; });
$parcel$export(module.exports, "CtaBtnText", function () { return $37d29093f218a0c9$export$7f370599117a54aa; });
$parcel$export(module.exports, "Edition", function () { return $37d29093f218a0c9$export$6f4a0f769e61929; });
$parcel$export(module.exports, "PRICE_FINDER_CONTAINER", function () { return $37d29093f218a0c9$export$c5526af38120e3f; });
$parcel$export(module.exports, "COMPARE_FEATURES_CONTAINER", function () { return $37d29093f218a0c9$export$67b29c0af8205db6; });
const $37d29093f218a0c9$export$bd7123388de718a2 = {
    desktop: `@media (min-width: 1024px)`,
    tablet: `@media (max-width: 1023px)`,
    mobile: `@media (max-width: 768px)`,
    extraSmall: `@media (max-width: 360px)`
};
const $37d29093f218a0c9$export$9a56b303ccc53008 = {
    unitTierBox: "pricing_page_unit_tier_box",
    unitDescriptionTooltipTriggered: "unit-description-tooltip-triggered",
    billingCycleChanged: "billing-cycle-changed",
    planCardCTAButtonClicked: "edition-table-button-clicked",
    unitBreachModalDecision: "unit-breach-modal-decision",
    unitLimitBreachModal: "unit-limit-breach-modal",
    userTierTooltipTriggered: "user-tier-tooltip-triggered",
    showPricingExampleTriggered: "show-pricing-example-triggered",
    hidePricingExampleTriggered: "hide-pricing-example-triggered",
    pricingExampleBillingCycleChanged: "pricing-example-billing-cycle-changed",
    promoCardCTAButtonClicked: "promo-card-button-clicked"
};
const $37d29093f218a0c9$export$803d5f8ee4072798 = {
    users: "users",
    agents: "agents"
};
const $37d29093f218a0c9$export$b1f75679747bdf24 = "US";
const $37d29093f218a0c9$export$427ae666c2c86a64 = "USD";
const $37d29093f218a0c9$export$3f5e519890ec420 = {
    FREE: "Free",
    STARTER: "Starter",
    STANDARD: "Standard",
    PREMIUM: "Premium",
    ENTERPRISE: "Enterprise"
};
const $37d29093f218a0c9$export$c6264333cd6ce1a4 = {
    confluence: "pricingplan.confluence.ondemand",
    jiraSoftware: "jira-software.ondemand",
    jiraServiceDesk: "jira-servicedesk.ondemand",
    jiraServiceManagement: "jira-servicedesk.ondemand",
    bitbucket: "com.atlassian.bitbucket.manual",
    atlassianGuard: "com.atlassian.identity-manager",
    compass: "compass.ondemand",
    jiraProductDiscovery: "jira-product-discovery.ondemand",
    rovo: "rovo",
    trello: "trello",
    loom: "loom",
    teamworkCollection: "teamwork-collection",
    strategyCollection: "strategy-collection"
};
const $37d29093f218a0c9$export$49640008eae271a8 = {
    confluence: "confluence",
    jiraSoftware: "jira-software",
    jiraServiceDesk: "jira-servicedesk",
    jiraServiceManagement: "jira-servicedesk",
    atlassianGuard: "atlassian-access",
    compass: "compass",
    jiraProductDiscovery: "jira-product-discovery",
    rovo: "rovo-org-purchase-sku",
    trello: "trello",
    loom: "loom"
};
const $37d29093f218a0c9$export$2766faac8d5287ee = {
    confluence: "pricingplan.confluence-data-center",
    jiraSoftware: "jira-software.data-center",
    jiraServiceDesk: "jira-servicedesk.data-center",
    jiraServiceManagement: "jira-servicedesk.data-center",
    bitbucket: "pricingplan.stash-data-center"
};
const $37d29093f218a0c9$export$9bb4a98475a54313 = {
    JSM: "jira-servicedesk.ondemand",
    BITBUCKET: "com.atlassian.bitbucket.manual"
};
const $37d29093f218a0c9$export$dcfb07a55b760b78 = {
    UNIT_LIMIT_FREE: 10,
    UNIT_LIMIT: 150000,
    UNIT_MIN_ENTERPRISE: 801
};
const $37d29093f218a0c9$export$d5367d5d99549333 = {
    FIXED_COST: "FIXED_COST",
    MARGINAL_PER_UNIT: "MARGINAL_PER_UNIT",
    PER_UNIT: "PER_UNIT"
};
function $37d29093f218a0c9$export$a97d19165664aecc(value) {
    switch(value){
        case $37d29093f218a0c9$export$d5367d5d99549333.FIXED_COST:
        case $37d29093f218a0c9$export$d5367d5d99549333.MARGINAL_PER_UNIT:
        case $37d29093f218a0c9$export$d5367d5d99549333.PER_UNIT:
            return true;
        default:
            return false;
    }
}
function $37d29093f218a0c9$export$b136e5eb1cbda98a(value) {
    if ($37d29093f218a0c9$export$a97d19165664aecc(value)) return value;
    else throw new SyntaxError(`${value} is not a valid PricingStrategy`);
}
const $37d29093f218a0c9$export$3d9423ec9a4e8352 = "https://id.atlassian.com/signup?application=trello&continue=https%3A%2F%2Ftrello.com%2Fauth%2Fatlassian%2Fcallback%3Fdisplay%3DeyJ2ZXJpZmljYXRpb25TdHJhdGVneSI6InNvZnQifQ%253D%253D&display=eyJ2ZXJpZmljYXRpb25TdHJhdGVneSI6InNvZnQifQ%3D%3D";
const $37d29093f218a0c9$export$3c460f2e36dca740 = "/try/cloud/signup";
const $37d29093f218a0c9$export$cee779d81c7e245b = "/enterprise/contact?formType=pricing-quotes";
const $37d29093f218a0c9$export$7f370599117a54aa = {
    GET_IT_NOW: "Get it now",
    START_FREE_TRIAL: "Start free trial",
    CONTACT_SALES: "Contact sales",
    JOIN_WAITLIST: "Join waitlist"
};
const $37d29093f218a0c9$export$6f4a0f769e61929 = {
    FREE: "free",
    STANDARD: "standard",
    PREMIUM: "premium",
    ENTERPRISE: "enterprise"
};
const $37d29093f218a0c9$export$c2f12bc66b1c3231 = 67;
const $37d29093f218a0c9$export$e528a8f1399647be = 210;
const $37d29093f218a0c9$export$27ed77542911fb0e = 1024;
const $37d29093f218a0c9$export$c5526af38120e3f = "priceBlock";
const $37d29093f218a0c9$export$67b29c0af8205db6 = "priceFeaturesTable";

});


parcelRegister("2oGlC", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = Promise.all([
    $eao4m("f3igF"),
    $eao4m("fGv84")
]).then(()=>parcelRequire('9pugI'));

});




parcelRegister("437NE", function(module, exports) {
$parcel$export(module.exports, "useNonProfitPricingCalculatorData", function () { return $79b000344fbd80a7$export$5805edf503905c58; });

var $1oC0p = parcelRequire("1oC0p");

var $fNAVV = parcelRequire("fNAVV");
const $79b000344fbd80a7$export$5805edf503905c58 = ()=>{
    const [plansDataByProduct, setPlansDataByProduct] = (0, $1oC0p.useState)();
    const [error, setError] = (0, $1oC0p.useState)();
    const loadPricingCalculatorData = (0, $1oC0p.useCallback)(async ()=>{
        try {
            const result = await (0, $fNAVV.getNonprofitPricingCalculatorData)();
            setPlansDataByProduct(result);
        } catch (err) {
            setError(err);
        }
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        loadPricingCalculatorData();
    }, [
        loadPricingCalculatorData
    ]);
    return {
        plansDataByProduct: plansDataByProduct,
        error: error
    };
};

});


parcelRegister("g7wmQ", function(module, exports) {
$parcel$export(module.exports, "Banner", function () { return $fb264eb8fd8740ec$export$3b4e64e77073e307; });
/* banner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $kbpa7 = parcelRequire("kbpa7");

var $btggB = parcelRequire("btggB");
const $fb264eb8fd8740ec$var$bannerContainerCss = null;
const $fb264eb8fd8740ec$var$bodyCss = null;
const $fb264eb8fd8740ec$export$3b4e64e77073e307 = ()=>{
    const isGwp10027 = (0, $btggB.getIsGwp10027NonprofitPricingPage)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_bfhk17la _1e0c1txw _1bah1h6o _y3gn1e5h _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _uj6k1h6o"
        ]),
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_syazu67f _1wyb7vkz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fbxu3 _1bsb1osq _1kny1nu9 _13pm1r31 _1dzg8stv _t1u2nqa1"
            ]),
            children: [
                isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.banner.body.isGwp10027",
                    defaultMessage: "Small social impact teams can now access Teamwork Collection apps at 100% off."
                }),
                !isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.banner.body.gwp7869",
                    defaultMessage: "Social Enterprises are now eligible for Atlassian\u2019s discounted apps and support programs!"
                })
            ]
        })
    });
};

});

parcelRegister("fZJZd", function(module, exports) {
$parcel$export(module.exports, "EligibleSection", function () { return $12df217695235bc1$export$1830bba02ce6e4ac; });
/* eligible-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $hnmMQ = parcelRequire("hnmMQ");

var $iPPTB = parcelRequire("iPPTB");

var $btggB = parcelRequire("btggB");

var $61SXF = parcelRequire("61SXF");
const $12df217695235bc1$var$eligibleContainerCss = null;
const $12df217695235bc1$var$headerCss = null;
const $12df217695235bc1$var$subtitleCss = null;
const $12df217695235bc1$var$ctaBlockCss = null;
const $12df217695235bc1$var$ctaBlockContentCss = null;
const $12df217695235bc1$var$ctaBlockTitleCss = null;
const $12df217695235bc1$var$ctaBlockDetailCss = null;
const $12df217695235bc1$var$imageCss = null;
const $12df217695235bc1$export$1830bba02ce6e4ac = ()=>{
    const intl = (0, $8e22h.default)();
    const isGwp10027 = (0, $btggB.getIsGwp10027NonprofitPricingPage)();
    const learnMore = intl.formatMessage({
        id: "NonprofitPage.eligible.cta.content.link",
        defaultMessage: "Learn more"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_1wybzwfg _vwz410mc _k48p9y44 _19pkidpf _2hwxidpf _otyrdlk8 _18u0idpf _1s18ckbl _17gqckbl _15flidpf _1d2widpf _1svy7vkz _seovidpf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.eligible.header",
                    defaultMessage: "Who\u2019s eligible"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                className: (0, $2jatx.default)([
                    "_1wyb7vkz _vwz41tcg _k48p1nn1 _19pkidpf _2hwx1wug _otyr19bv _18u01wug _1s18gktf _17gq1f4h _b8yqbxu3 _15flidpf _1d2w1wug _1svygktf _seov1wug _3p1c1f4h _py5o1ylp _10jx1osq"
                ]),
                children: isGwp10027 ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.eligible.subtitle.gwp10027",
                    defaultMessage: "50% - 100% off discounts are available for nonprofits and social enterprises that are:"
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.eligible.subtitle.gwp7869",
                    defaultMessage: "Discounts on Atlassian Cloud apps are available to nonprofits and social enterprises that are:"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $61SXF.EligibilityListGwp7869), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1h6o _1bsb1osq _19pk12am _2hwxidpf _otyridpf _18u0idpf _1lrw1sh2 _12veeva1 _ca0q4bvh _u5f37vkz _n3td4bvh _19bv7vkz _kqswh2mm _1itk1sc7 _13hp18tu _b2g019fs _i6jx16xz _1lh77vkz _z3nc16xz _wpai7vkz _1vkhvle5 _7uci11oj _2cw21ssb _1l142xu9"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _1bah1h6o _1ako7vkz _c7s77vkz _4puvzwfg _1r3v7vkz"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                            className: (0, $2jatx.default)([
                                "_1wyb1tcg _vwz41ul9 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "NonprofitPage.eligible.cta.title",
                                defaultMessage: "Need more info?"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            className: (0, $2jatx.default)([
                                "_1wyb7vkz _vwz41tcg"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "NonprofitPage.eligible.cta.content",
                                defaultMessage: "Get the answers for your most frequently asked eligibility questions."
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                            text: learnMore,
                            "aria-label": learnMore,
                            href: "#faq",
                            type: "primary",
                            dataEventProps: {
                                "data-event-component": "linkButton",
                                // @ts-expect-error value
                                "data-event-container": "Eligibility section",
                                "data-event": "clicked",
                                "data-product-key": "nonProfitCalculator"
                            }
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_p12f1obz _c71l7iqz _kqswstnw _rjxp1wqo _u7co15qf _mezj12it _bna712it _p5ceka7h _enhl9by0 _j0lc1osq _1jtm1osq _1t06x19p _wtm5ka7h"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                image: {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8fhb444317uecxj0n4dy144u8atr503c.webp",
                                    alt: ""
                                }
                            })
                        })
                    ]
                })
            })
        ]
    });
};
$12df217695235bc1$export$1830bba02ce6e4ac.displayName = "EligibleSection";

});
parcelRegister("61SXF", function(module, exports) {
$parcel$export(module.exports, "EligibilityListGwp7869", function () { return $2ffcccaddfe16e55$export$c64766b093b22842; });
/* eligibility-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");
const $2ffcccaddfe16e55$export$5a8c33720cbdacee = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("ul", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1n261g80 _1bah1yb4 _2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1cqi1ssb _498vusvi _1gee7vkz _18ts7vkz _75fp7vkz _r0eh7vkz _1yp81x1l"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($2ffcccaddfe16e55$var$NonGovernmental, {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                        image: {
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1665m6o0xxrphegnh7lnwf17585pj211.svg",
                            alt: ""
                        }
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                        className: (0, $2jatx.default)([
                            "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf _1s181tcg _17gq1ul9"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "NonprofitPage.card.title2",
                            defaultMessage: "Non-commercial"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fpcwi"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "NonprofitPage.card.content2",
                            defaultMessage: "operating on a not-for-profit basis and for the public benefit"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($2ffcccaddfe16e55$var$NonPolitical, {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)($2ffcccaddfe16e55$var$Nonprofit, {})
        ]
    });
};
const $2ffcccaddfe16e55$export$c64766b093b22842 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("ul", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1n261g80 _1bah1yb4 _2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1cqi1ssb _498vusvi _1gee7vkz _18ts7vkz _75fp7vkz _r0eh7vkz _1yp81x1l"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($2ffcccaddfe16e55$var$NonGovernmental, {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)($2ffcccaddfe16e55$var$NonPolitical, {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)($2ffcccaddfe16e55$var$Nonprofit, {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                        image: {
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1665m6o0xxrphegnh7lnwf17585pj211.svg",
                            alt: ""
                        }
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                        className: (0, $2jatx.default)([
                            "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf _1s181tcg _17gq1ul9"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "NonprofitPage.card.socialMissionTitle",
                            defaultMessage: "For-profit with a social mission"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fpcwi"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "NonprofitPage.card.socialMissionContent",
                            defaultMessage: "<a>as defined by Atlassian</a> and verified by Goodstack",
                            values: {
                                a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                        href: "#faq",
                                        className: (0, $2jatx.default)([
                                            "_syaz17la _4bfu1r31 _1hms8stv _ajmmnqa1"
                                        ]),
                                        style: {
                                            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                                        },
                                        children: chunks
                                    })
                            }
                        })
                    })
                ]
            })
        ]
    });
};
const $2ffcccaddfe16e55$var$NonGovernmental = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/4vunf5vd4cboe8glor3vep3mam3a3d0o.svg",
                    alt: ""
                }
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                className: (0, $2jatx.default)([
                    "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf _1s181tcg _17gq1ul9"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.card.title1",
                    defaultMessage: "Non-governmental"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fpcwi"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.card.content1",
                    defaultMessage: "independent from government control"
                })
            })
        ]
    });
};
const $2ffcccaddfe16e55$var$NonPolitical = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/k1y270i4t5e33yp8hw62tn3l37850050.svg",
                    alt: ""
                }
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                className: (0, $2jatx.default)([
                    "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf _1s181tcg _17gq1ul9"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.card.title3",
                    defaultMessage: "Non-political"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fpcwi"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.card.content3",
                    defaultMessage: "or against any political party, candidate, or campaign"
                })
            })
        ]
    });
};
const $2ffcccaddfe16e55$var$Nonprofit = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8q882ia8oh77fl481x8f01up4y2a2q18.svg",
                    alt: ""
                }
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                className: (0, $2jatx.default)([
                    "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf _1s181tcg _17gq1ul9"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.card.title4",
                    defaultMessage: "Recognized as a nonprofit"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fpcwi"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.card.content4",
                        defaultMessage: "in the country in which you are registered, in accordance with the "
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                        target: "_blank",
                        href: "https://goodstack.org/nonprofit-definitions",
                        rel: "noreferrer",
                        className: (0, $2jatx.default)([
                            "_syaz17la _4bfu1r31 _1hms8stv _ajmmnqa1"
                        ]),
                        style: {
                            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "NonprofitPage.card.content4.link",
                            defaultMessage: "eligibility criteria for that country"
                        })
                    })
                ]
            })
        ]
    });
};
const $2ffcccaddfe16e55$var$rowWrapperCss = null;
const $2ffcccaddfe16e55$var$cardTitleCss = null;
const $2ffcccaddfe16e55$var$cardContentCss = null;
const $2ffcccaddfe16e55$var$cardContentLinkCss = null;

});


parcelRegister("4bEWc", function(module, exports) {
$parcel$export(module.exports, "EnterpriseSection", function () { return $2c55cd82052437a3$export$f366cf0ae8139431; });
/* enterprise-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $2ivuE = parcelRequire("2ivuE");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");
const $2c55cd82052437a3$export$f366cf0ae8139431 = ()=>{
    const localizedCTAHRef = (0, $jQ0cd.useLocalizedHref)("/software/views/community-license-request#/");
    const containerStyles = null;
    const pictureStyles = null;
    const contentBlockStyles = null;
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1bsb1osq _p12f5o3v _zulpoahv _yv0ewxkt _4cvr1h6o _y3gn1e5h _1ph4hkll _gu181h6o _1qgn1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                        image: {
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/scjwn81w6s2ardgn7641002jp2ye5252.svg",
                            alt: ""
                        },
                        className: (0, $2jatx.default)([
                            "_6rthpxbi"
                        ])
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), {
                        headerType: "h3",
                        headerText: intl.formatMessage({
                            id: "NonprofitPage.enterprise-section.heading.gwp7869",
                            defaultMessage: "Enterprise plans are 50% off for eligible nonprofits and social enterprises."
                        }),
                        ctaProps: {
                            buttonProps: {
                                text: intl.formatMessage({
                                    id: "NonprofitPage.enterprise-section.cta",
                                    defaultMessage: "Apply now"
                                }),
                                url: localizedCTAHRef
                            }
                        },
                        className: (0, $2jatx.default)([
                            "_1axibfyo _r8ntni7l _ggmhxy5q _qliy1hlo"
                        ]),
                        style: {
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1rg21ssb _1h6o1ssb _rtys1osq _15pj1osq _bna71wug _1r2v1wug _1cr61wug _dusl1wug _1hlx1wug _atom1wug _18741wug _2t2f1wug _10ew1wug _1iya1wug"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/334g168on374sch67v7r1lrv174i8psc.webp",
                        alt: ""
                    }
                })
            })
        ]
    });
};
$2c55cd82052437a3$export$f366cf0ae8139431.displayName = "EnterpriseSection";

});

parcelRegister("71t0B", function(module, exports) {
$parcel$export(module.exports, "Fineprint", function () { return $a19187bc89cb8b37$export$3fb2e06c2eeca703; });
/* fineprint.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $btggB = parcelRequire("btggB");
const $a19187bc89cb8b37$var$fineprintContainerCss = null;
const $a19187bc89cb8b37$var$headerCss = null;
const $a19187bc89cb8b37$var$bodyCss = null;
const $a19187bc89cb8b37$export$3fb2e06c2eeca703 = ()=>{
    const isGwp10027 = (0, $btggB.getIsGwp10027NonprofitPricingPage)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_1wybzwfg _k48p9y44 _19pkidpf _2hwxidpf _otyrdlk8 _18u0idpf _1s18ckbl _15flidpf _1d2widpf _1svy7vkz _seovidpf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.fineprint.header",
                    defaultMessage: "The fine print"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                className: (0, $2jatx.default)([
                    "_1wyb7vkz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fbxu3"
                ]),
                children: [
                    isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.fineprint.body.gwp10027",
                        defaultMessage: "Atlassian aims to unleash the potential of every team, including nonprofits and social enterprises, but not every organization may meet Atlassian\u2019s Social Impact License eligibility criteria."
                    }),
                    !isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.fineprint.body",
                        defaultMessage: "Atlassian aims to unleash the potential of every team, including nonprofits and social enterprises, but not every organization may meet Atlassian\u2019s Community License eligibility criteria."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                className: (0, $2jatx.default)([
                    "_1wyb7vkz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fbxu3"
                ]),
                children: [
                    isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.fineprint.body.additional",
                        defaultMessage: "Atlassian verifies Social Impact License eligibility in partnership with Goodstack, yet determines qualification for discounted licenses at its sole discretion. We reserve the right to grant or deny an individual or organization\u2019s application for a discounted license, or to discontinue an active discounted license, at any time, for any reason, and to supplement or amend our Social Impact License eligibility guidelines at any time."
                    }),
                    !isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.fineprint.body.additional",
                        defaultMessage: "Atlassian verifies Community License eligibility in partnership with Goodstack, yet determines qualification for discounted licenses at its sole discretion. We reserve the right to grant or deny an individual or organization\u2019s application for a discounted license, or to discontinue an active discounted license, at any time, for any reason, and to supplement or amend our Community License eligibility guidelines at any time."
                    })
                ]
            })
        ]
    });
};
$a19187bc89cb8b37$export$3fb2e06c2eeca703.displayName = "FineprintSection";

});

parcelRegister("gtK7Z", function(module, exports) {
$parcel$export(module.exports, "Hero", function () { return $1f97debb6b62cf0e$export$887967f05dc521ae; });
/* hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $lmQGF = parcelRequire("lmQGF");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $btggB = parcelRequire("btggB");
const $1f97debb6b62cf0e$var$heroContainerCss = null;
const $1f97debb6b62cf0e$var$contentBoxCss = null;
const $1f97debb6b62cf0e$var$preheaderCss = null;
const $1f97debb6b62cf0e$var$titleCss = null;
const $1f97debb6b62cf0e$var$subtitleCss = null;
const $1f97debb6b62cf0e$var$mobileImageCss = null;
const $1f97debb6b62cf0e$export$887967f05dc521ae = ()=>{
    const ctaButtonUrl = "/software/views/community-license-request#/";
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _1reo15vq _18m915vq _1bsb1osq _1gnk1029 _p17a18tu _1u5reva1 _rb2g8y3i _ij141rp3 _1odr1on4 _18xueva1 _1o60asht"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_syaz1hlo _y3gn1h6o _kqswh2mm _1q51zwfg _p12f1fra _1waf16xz _44j9idpf _1tz91y44 _1enu1f4h"
            ]),
            style: {
                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("h5", {
                    className: (0, $2jatx.default)([
                        "_1wybf6fq _vwz41ou6 _1pfhidpf _6rth1skh _k48p1fw0 _1s18gktf _17gq1f4h _1ob91tcg"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.hero.preheader",
                        defaultMessage: "ATLASSIAN FOR NONPROFITS"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                    className: (0, $2jatx.default)([
                        "_1wyb1wqb _vwz4ymf6 _k48p1nn1 _1pfhidpf _6rthf6fq _1s18ymf6 _17gqys9h _b8yq1ogm _jhy41nn1"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.hero.title",
                        defaultMessage: "Pricing that fits your nonprofit\u2019s budget"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                    className: (0, $2jatx.default)([
                        "_1wybgktf _vwz41f4h _p12f1178 _k48powjs _19pkidpf _2hwx1wug _otyr1skh _18u01wug _1s181f4h _17gq1ylp _b8yq1kdj _15flidpf _1d2w1wug _1svyo7ao _seov1wug"
                    ]),
                    children: (0, $btggB.getIsGwp10027NonprofitPricingPage)() ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.hero.subtitle.gwp10027",
                        defaultMessage: "Get free and discounted Atlassian apps for nonprofit and social enterprise teams"
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.hero.subtitle.gwp7869",
                        defaultMessage: "Get discounted Atlassian apps for nonprofit and social enterprise teams"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                    variant: "primary",
                    size: "small",
                    color: "blue",
                    href: (0, $jQ0cd.useLocalizedHref)(ctaButtonUrl),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.hero.button",
                        defaultMessage: "Apply now"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _1bsbixjv _4t3iva7c _1sjrglyw _mezj1osq _bna71osq"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                        image: {
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8p5v165n7f507j620h6738eoudo17oae.svg",
                            alt: ""
                        }
                    })
                })
            ]
        })
    });
};

});

parcelRegister("k53CY", function(module, exports) {
$parcel$export(module.exports, "NonprofitCalculatorHeading", function () { return $5c9f5bc678cf4f45$export$ea62e9564a56df6c; });
/* nonprofit-calculator-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");
const $5c9f5bc678cf4f45$export$ea62e9564a56df6c = ()=>{
    const headingStyles = null;
    const subtitleStyles = null;
    const imgStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _zulpftgi _p12fbxu3 _kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_k48p9y44 _1wyb1ylp _vwz48vuz _y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fz8o0 _1s18ckbl _b8yqstmo _syaz1hlo"
                ]),
                style: {
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.calculator.heading",
                    defaultMessage: "Choose the tools and pricing that fit your team"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_p12fkbql _y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.calculator.subheading.gwp7869",
                    defaultMessage: "Use our pricing calculator to get a <bold>discounted pricing estimate</bold> available to nonprofits and social enterprises.",
                    values: {
                        // eslint-disable-next-line react/no-unstable-nested-components
                        bold: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_k48p8n31"
                                ]),
                                children: chunks
                            })
                    }
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/27360l8wso6a72x4e44yyg66uak8r51f.svg",
                    alt: ""
                },
                className: (0, $2jatx.default)([
                    "_1e0cglyw _kqswstnw _4t3ivrzy _1bsb1dqv _mmgk1wqo _kzvi1ule _11901pbv _dm251ule"
                ])
            })
        ]
    });
};
$5c9f5bc678cf4f45$export$ea62e9564a56df6c.displayName = "TabbedCalculatorHeadingSection";

});

parcelRegister("lSpoK", function(module, exports) {
$parcel$export(module.exports, "NonprofitNav", function () { return $6309917ad16a803d$export$4dfedf5c077d010b; });
/* nonprofit-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $jQ0cd = parcelRequire("jQ0cd");

var $iOXki = parcelRequire("iOXki");
const $6309917ad16a803d$var$NonprofitLogo = ()=>{
    const logoCss = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_1e0c1mog _1wyb1k92 _ca0q1ou6 _u5f3idpf _n3tdgktf _19bvidpf _k48pni7l"
        ]),
        children: "Nonprofits"
    });
};
const $6309917ad16a803d$export$4dfedf5c077d010b = ()=>{
    const intl = (0, $8e22h.default)();
    const eligibilityHref = (0, $jQ0cd.useLocalizedHref)("/teams/nonprofits/discount-pricing");
    const supportPrograms = (0, $jQ0cd.useLocalizedHref)("/teams/nonprofits/support-programs");
    const resource = (0, $jQ0cd.useLocalizedHref)("/teams/nonprofits/resources");
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "nonprofit-nav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
            isShowTryNowLink: false,
            productLogoUrl: "/teams/nonprofits",
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($6309917ad16a803d$var$NonprofitLogo, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "NonprofitPageTemplate.navbar.nonprofit-logo",
                defaultMessage: "Nonprofit logo"
            }),
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($6309917ad16a803d$var$NonprofitLogo, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: "pricing",
                    linkText: intl.formatMessage({
                        id: "NonprofitPageTemplate.navbar.pricing",
                        defaultMessage: "Eligibility and pricing"
                    }),
                    hasSubnav: false,
                    productKey: "nonprofit",
                    href: eligibilityHref
                },
                {
                    globalLinksKey: "support",
                    linkText: intl.formatMessage({
                        id: "NonprofitPageTemplate.navbar.support",
                        defaultMessage: "Support programs"
                    }),
                    hasSubnav: false,
                    productKey: "nonprofit",
                    href: supportPrograms
                },
                {
                    globalLinksKey: "resources",
                    linkText: intl.formatMessage({
                        id: "NonprofitPageTemplate.navbar.resources",
                        defaultMessage: "Resources"
                    }),
                    hasSubnav: false,
                    productKey: "nonprofit",
                    href: resource
                }
            ],
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-nonprofit",
                    mobileLinksProps: [
                        {
                            globalLinksKey: "pricing",
                            linkText: intl.formatMessage({
                                id: "NonprofitPageTemplate.navbar.pricing",
                                defaultMessage: "Eligibility and pricing"
                            }),
                            hasSubnav: false,
                            productKey: "nonprofit",
                            href: eligibilityHref
                        },
                        {
                            globalLinksKey: "support",
                            linkText: intl.formatMessage({
                                id: "NonprofitPageTemplate.navbar.support",
                                defaultMessage: "Support programs"
                            }),
                            hasSubnav: false,
                            productKey: "nonprofit",
                            href: supportPrograms
                        },
                        {
                            globalLinksKey: "resources",
                            linkText: intl.formatMessage({
                                id: "NonprofitPageTemplate.navbar.resources",
                                defaultMessage: "Resources"
                            }),
                            hasSubnav: false,
                            productKey: "nonprofit",
                            href: resource
                        }
                    ]
                }
            ]
        })
    });
};

});

parcelRegister("hJy82", function(module, exports) {
$parcel$export(module.exports, "OfficialSection", function () { return $a3701dad3ae12d03$export$dba159851b545af3; });
/* official-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $lmQGF = parcelRequire("lmQGF");

var $hnmMQ = parcelRequire("hnmMQ");

var $jQ0cd = parcelRequire("jQ0cd");

var $btggB = parcelRequire("btggB");
const $a3701dad3ae12d03$var$buttonStyle = null;
const $a3701dad3ae12d03$var$officialContainerCss = null;
const $a3701dad3ae12d03$var$headerCss = null;
const $a3701dad3ae12d03$var$subtitleCss = null;
const $a3701dad3ae12d03$var$rowWrapperCss = null;
const $a3701dad3ae12d03$var$cardTitleCss = null;
const $a3701dad3ae12d03$var$imageCss = null;
const $a3701dad3ae12d03$export$dba159851b545af3 = ()=>{
    const isGwp10027 = (0, $btggB.getIsGwp10027NonprofitPricingPage)();
    const ctaButtonUrl = "/software/views/community-license-request#/";
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o _kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_1wybzwfg _vwz410mc _k48p9y44 _19pkidpf _2hwx1wug _otyrdlk8 _18u01wug _p12f1y37 _1s18ckbl _17gqckbl _b8yqbxu3 _15flidpf _1d2w1wug _1svy7vkz _seov1wug"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.official.header",
                    defaultMessage: "Let\u2019s make it official"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("h3", {
                className: (0, $2jatx.default)([
                    "_1wyb7vkz _vwz41tcg _k48p1nn1 _19pkidpf _2hwx1wug _otyr19bv _18u01wug _p12f1y37 _1lzogktf _119z1f4h _lg5ridpf _d97m1wug _1b7egktf _12521wug _3p1c1f4h _py5o1ylp _10jxbxu3 _dbjgidpf _1hvk1wug _isu4gktf _15qm1wug"
                ]),
                children: [
                    isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.official.subtitle.gwp10027",
                        defaultMessage: "Apply for your Social Impact License. Here\u2019s how it\u2019ll work."
                    }),
                    !isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.official.subtitle",
                        defaultMessage: "Apply to verify your eligibility and receive your discounted Community License. Here\u2019s how it\u2019ll work."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                variant: "primary",
                size: "small",
                color: "blue",
                href: (0, $jQ0cd.useLocalizedHref)(ctaButtonUrl),
                className: (0, $2jatx.default)([
                    "_2rko1y44 _19pkidpf _2hwx1wug _otyr1tcg _18u01wug"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.hero.button",
                    defaultMessage: "Apply now"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("ul", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1n261g80 _1bah1yb4 _2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1cqi1ssb _498vusvi _1gee7vkz _18ts7vkz _75fp7vkz _r0eh7vkz _1yp81x1l"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                image: {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1665m6o0xxrphegnh7lnwf17585pj211.svg",
                                    alt: ""
                                }
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("h4", {
                                className: (0, $2jatx.default)([
                                    "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf"
                                ]),
                                children: [
                                    isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "NonprofitPage.official.card.title1.gwp10027",
                                        defaultMessage: "1. Choose your apps and get started with a free trial"
                                    }),
                                    !isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "NonprofitPage.official.card.title1.v2",
                                        defaultMessage: "1. Choose your apps, calculate pricing, and sign up for a free plan or trial"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                image: {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ok813kjv073y16g445ogp8yerkv6qvc2.svg",
                                    alt: ""
                                }
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("h4", {
                                className: (0, $2jatx.default)([
                                    "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf"
                                ]),
                                children: [
                                    isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "NonprofitPage.official.card.title2.gwp10027",
                                        defaultMessage: "2. Apply for a Social Impact License"
                                    }),
                                    !isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "NonprofitPage.official.card.title2",
                                        defaultMessage: "2. Apply for your discounted license"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                image: {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/h1503x520p8bg7w744h810188q4bypf3.svg",
                                    alt: ""
                                }
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                                className: (0, $2jatx.default)([
                                    "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "NonprofitPage.official.card.title3",
                                    defaultMessage: "3. In 2-3 days, verification approved and received!"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                image: {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/pe077p727atw2c04p00h3ecl1on0p841.svg",
                                    alt: ""
                                }
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("h4", {
                                className: (0, $2jatx.default)([
                                    "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf"
                                ]),
                                children: [
                                    isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "NonprofitPage.official.card.title4.gwp10027",
                                        defaultMessage: "4. 50-100% discount automatically applied to your subscription"
                                    }),
                                    !isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "NonprofitPage.official.card.title4",
                                        defaultMessage: "4. Discount automatically applied to your subscription and any future upgrades"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_p12f1k4y _c71l4bvh _kqswstnw _rjxp4l2f _u7co1a11 _j6qu146b _1pn4ucft _p5ce16gx _enhl1vuk _j0lc12it _1jtm12it _10jxmgvx _1jc2mhvn _1t0616gx _wtm512it _18oi1osq _1ky91osq"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/g626i0m4331tsgn2313fln510p5578n1.svg",
                        alt: ""
                    }
                })
            })
        ]
    });
};
$a3701dad3ae12d03$export$dba159851b545af3.displayName = "OfficialSection";

});

parcelRegister("3icmm", function(module, exports) {
$parcel$export(module.exports, "ResourcesSection", function () { return $e3ba3f7a269b5999$export$3f0336208d56829f; });
/* resources-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $jQ0cd = parcelRequire("jQ0cd");

var $1rGpC = parcelRequire("1rGpC");

var $NtjLk = parcelRequire("NtjLk");

var $btggB = parcelRequire("btggB");
const $e3ba3f7a269b5999$var$resourcesContainerCss = null;
const $e3ba3f7a269b5999$var$headerCss = null;
const $e3ba3f7a269b5999$var$subtitleCss = null;
const $e3ba3f7a269b5999$var$cardBlockCss = null;
const $e3ba3f7a269b5999$export$3f0336208d56829f = ()=>{
    const intl = (0, $8e22h.default)();
    const teamCardProps = {
        title: intl.formatMessage({
            id: "NonprofitPage.resources.team.title",
            defaultMessage: "Team up with us"
        }),
        titleAs: "h3",
        body: intl.formatMessage({
            id: "NonprofitPage.resources.team.body",
            defaultMessage: "Get free, customized app and teamwork coaching sessions with Atlassian experts. No question is too big or too small."
        }),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/7g2k6ru6bw83f33121usy12j03td6p88.webp",
            alt: "Partners for Nonprofits"
        },
        callToAction: {
            href: (0, $jQ0cd.useLocalizedHref)("/teams/nonprofits/support-programs"),
            text: intl.formatMessage({
                id: "NonprofitPage.resources.team.link",
                defaultMessage: "Learn more"
            })
        }
    };
    const isGwp10027 = (0, $btggB.getIsGwp10027NonprofitPricingPage)();
    const successCardProps = {
        title: intl.formatMessage({
            id: "NonprofitPage.resources.success.title.gwp7869",
            defaultMessage: "Social impact team success stories"
        }),
        titleAs: "h3",
        body: intl.formatMessage({
            id: "NonprofitPage.resources.success.body",
            defaultMessage: "Get inspired by teams like yours driving impact with Atlassian apps."
        }),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6kp84so85h055h6o517q02jx1qp42p78.webp",
            alt: "Partners for Nonprofits"
        },
        callToAction: {
            href: (0, $jQ0cd.useLocalizedHref)("/teams/nonprofits/resources"),
            text: intl.formatMessage({
                id: "NonprofitPage.resources.success.link",
                defaultMessage: "See all use cases"
            })
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_1wybzwfg _vwz410mc _k48p9y44 _19pkidpf _2hwxidpf _otyrdlk8 _18u0idpf _y3gn1h6o _1s18ckbl _17gq8vuz _15flidpf _1d2widpf _1svy7vkz _seovidpf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.resources.header.v1",
                    defaultMessage: "Explore resources"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("h3", {
                className: (0, $2jatx.default)([
                    "_1wyb7vkz _vwz41tcg _k48powjs _19pkidpf _2hwx1wug _otyrgktf _18u01wug _y3gn1h6o _1lzogktf _119z1f4h _j6qubxu3 _lg5ridpf _d97m1wug _1b7eldb6 _12521wug _3p1c1f4h _py5o1ylp _10jx1osq"
                ]),
                children: [
                    isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.resources.subtitle.gwp10027",
                        defaultMessage: "While you wait for your Social Impact License to be approved\u2026"
                    }),
                    !isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.resources.subtitle",
                        defaultMessage: "While you wait for your Community License to be approved\u2026"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_3intidpf _4fugidpf _1ynqidpf _1j3nidpf _quu71osq _18zx1h90"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
                    layout: "6-6",
                    className: (0, $2jatx.default)([
                        "_3intidpf _4fugidpf _1ynqidpf _1j3nidpf _quu71osq _18zx1h90"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $NtjLk.Card), {
                            ...teamCardProps
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $NtjLk.Card), {
                            ...successCardProps
                        })
                    ]
                })
            })
        ]
    });
};
$e3ba3f7a269b5999$export$3f0336208d56829f.displayName = "ResourcesSection";

});
parcelRegister("NtjLk", function(module, exports) {
$parcel$export(module.exports, "Card", function () { return $2da6ff99551ef1ce$export$60332b2344f7fe41; });
/* card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $hnmMQ = parcelRequire("hnmMQ");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");

var $8cYSw = parcelRequire("8cYSw");

var $iPPTB = parcelRequire("iPPTB");
const $2da6ff99551ef1ce$export$3c868f5963107f89 = {
    atlassian: "https://dam-cdn.atl.orangelogic.com/AssetLink/25o68v5s8lr856c06p606q47s76rs10f.svg",
    guard: "https://dam-cdn.atl.orangelogic.com/AssetLink/8j5d41rmb7q4himg4r42k3e84hvoo07i.svg"
};
const $2da6ff99551ef1ce$export$60332b2344f7fe41 = ({ align: align = "start", orientation: // we currently do not support a horizontal orientation card with an image
// the outstanding issue is that the the image has a requirement of an aspect ratio of 16:9
// and the card text is unbounded (so prioritizing the image would make the text potentially
// overflow), and prioritizing the text would make the image potentially have undesired
// white space at the end
orientation = "vertical", columns: columns, background: background = "light", eyebrow: eyebrow, logo: logo, title: title, body: body, image: image, icon: { linkedIcon: { url: iconUrl, size: iconSize = "medium", paddingIncluded: paddingIncluded = false } = {}, iconComponent: iconComponent } = {}, callToAction: callToAction, spotIllustration: spotIllustration, ...props })=>{
    // hedge against the value being passed in as a string (the options in uniform can only be string values)
    // which would subsequently fail a string vs number check ie 10 === "10" is false
    const numColumns = Number(columns);
    const { titleAs: TitleComponent = "h3", containerType: Container = "div" } = props;
    const isLinkableCard = !!callToAction;
    const uniqueId = (0, $1oC0p.useId)();
    const titleId = `card-title-${uniqueId}`;
    const callToActionId = `card-cta-${uniqueId}`;
    const bodyElement = typeof body === "string" ? /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_19pkgrf3 _2hwxgrf3 _otyrgrf3 _18u0grf3"
        ]),
        children: body
    }) : body;
    const card = /*#__PURE__*/ (0, $7VQPk.jsxs)(Container, {
        className: (0, $2jatx.default)([
            "_2rkovwyg _1e0c1txw _yyhy10md",
            align === "center" && "_4cvr1h6o _y3gn1h6o",
            background === "light" && "_11q7cd5j _19ityzqy",
            background === "dark" && "_11q75k8o _19it1hn0 _syazcd5j _cg41cd5j _qliycd5j _1rhqcd5j _jl6wcd5j _s974cd5j _125xcd5j _1evhcd5j _1suqcd5j",
            orientation === "vertical" && "_2lx21bp4",
            orientation === "horizontal" && "_2lx2vrvc _4t3i1osq _1bsb1osq _14q21bp4",
            isLinkableCard && "_kqswh2mm _v564mnji _13whb3bt _ykcxidpf _1heustnw _1w8ikb7n _1ni61kw8 _a7on1kw8 _clok130s _1v69130s"
        ]),
        style: {
            "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400")),
            "--_1ntr8rj": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark200")),
            "--_yrk0lp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark100"))
        },
        children: [
            spotIllustration ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1pfhxy5q _ahbqxy5q _12l2xy5q _6rthu2gc",
                    orientation === "horizontal" && "_12l2u2gc _1ob9xy5q",
                    "spotIllustrationContainer"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: spotIllustration.src,
                    alt: spotIllustration.alt ?? "",
                    style: {
                        width: spotIllustration.width ?? "auto"
                    },
                    className: (0, $2jatx.default)([
                        "_p12f1osq"
                    ])
                })
            }) : image && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1reozryt _18m9zryt",
                    orientation === "vertical" && "_1s1gvwyg _5fbcvwyg",
                    orientation === "horizontal" && "_1s1gvwyg _1yxnvwyg _4t3i1osq _1bsb1osq _1e0c1txw",
                    "cardImageContainer"
                ]),
                style: {
                    "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    ...image,
                    src: image.src,
                    alt: image.alt,
                    className: (0, $2jatx.default)([
                        "_1bsb1osq _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1txw"
                    ])
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1yt41ejb _1e0c1txw _2lx21bp4 _zulpu2gc",
                    orientation === "vertical" && "_16jlkb7n _1o9zkb7n _i0dlf1ug",
                    orientation === "horizontal" && "_1bsb1osq _4t3i1osq _1q51xy5q"
                ]),
                children: [
                    logo && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_19pkgrf3 _2hwxgrf3 _otyrgrf3 _18u0grf3"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                            image: {
                                src: $2da6ff99551ef1ce$export$3c868f5963107f89[logo],
                                alt: "",
                                height: 24
                            }
                        })
                    }),
                    iconUrl && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_6rthpxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                            src: iconUrl,
                            alt: "",
                            style: {
                                width: `${(0, $8cYSw.iconSizesPaddingIncluded)[iconSize]}px`,
                                height: `${(0, $8cYSw.iconSizesPaddingIncluded)[iconSize]}px`,
                                aspectRatio: "1",
                                padding: `${paddingIncluded ? 0 : ((0, $8cYSw.iconSizesPaddingIncluded)[iconSize] - (0, $8cYSw.iconSizesPaddingExcluded)[iconSize]) / 2}px`,
                                objectPosition: "center"
                            }
                        })
                    }),
                    iconComponent && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_6rthpxbi"
                        ]),
                        children: iconComponent
                    }),
                    eyebrow && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_19pkgrf3 _2hwxgrf3 _otyrgrf3 _18u0grf3",
                            "eyebrow-md"
                        ]),
                        children: eyebrow
                    }),
                    title && /*#__PURE__*/ (0, $7VQPk.jsx)(TitleComponent, {
                        className: (0, $2jatx.default)([
                            "_19pkgrf3 _2hwxgrf3 _otyrgrf3 _18u0grf3",
                            "card-title"
                        ]),
                        id: titleId,
                        children: title
                    }),
                    body && bodyElement,
                    isLinkableCard && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            orientation === "vertical" && "_1pfh1wug",
                            "_1q51pxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                            id: callToActionId,
                            ariaLabelledby: `${callToActionId} ${titleId}`,
                            type: "primary",
                            ...callToAction,
                            className: `full-card ${callToAction?.className ?? ""}`,
                            bgColor: background === "dark" ? "bgBlackBlue" : "bgWhite",
                            "aria-label": callToAction.text
                        })
                    })
                ]
            })
        ]
    });
    const fullWidthGridStyles = null;
    if (numColumns && orientation === "horizontal") return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_195g1wug _p12f1osq _1bsb1osq _13ltwklj _bozgzwfg _y4tizwfg _qwmh1wqb _yu8o1wqb _1j8bcx6w _1vsw1vi7 _d2ik1wqb _exxm1wqb _10jxzqdx _1e0c11p5 _vchhusvi _zulp14hz _1dsl1tcg _1qnyaw08 _n6am13k5"
            ]),
            style: {
                "--_18qdfwk": (0, $6ZVlx.default)(numColumns === 10 ? 2 : 1),
                "--_1xniuc0": (0, $6ZVlx.default)(numColumns === 10 ? 10 : 12)
            },
            children: card
        })
    });
    return card;
};
const $2da6ff99551ef1ce$var$cardContainer = null;
const $2da6ff99551ef1ce$var$cardContainerLight = null;
const $2da6ff99551ef1ce$var$cardContainerDark = null;
const $2da6ff99551ef1ce$var$illustrationContainer = null;
const $2da6ff99551ef1ce$var$horizontalIllustrationContainer = null;
const $2da6ff99551ef1ce$var$verticalOrientation = null;
const $2da6ff99551ef1ce$var$horizontalOrientation = null;
const $2da6ff99551ef1ce$var$centeredCardContainer = null;
const $2da6ff99551ef1ce$var$linkableCardContainer = null;
const $2da6ff99551ef1ce$var$cardImageContainer = null;
const $2da6ff99551ef1ce$var$horizontalImageContainer = null;
const $2da6ff99551ef1ce$var$verticalImageContainer = null;
const $2da6ff99551ef1ce$var$imageStyle = null;
const $2da6ff99551ef1ce$var$verticalBodyContainer = null;
const $2da6ff99551ef1ce$var$horizontalBodyContainer = null;
const $2da6ff99551ef1ce$var$cardBodyContainer = null;
const $2da6ff99551ef1ce$var$resetMargin = null;
const $2da6ff99551ef1ce$var$iconContainer = null;
const $2da6ff99551ef1ce$var$linkContainer = null;
const $2da6ff99551ef1ce$var$verticalLinkContainer = null;

});



parcelRegister("in9in", function(module, exports) {
$parcel$export(module.exports, "TrelloPriceFinder", function () { return $0e2ca0aa8f567d21$export$954e0f4d6ca6524; });

var $7VQPk = parcelRequire("7VQPk");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $hCc2m = parcelRequire("hCc2m");

var $g9ZvA = parcelRequire("g9ZvA");

var $gIRO7 = parcelRequire("gIRO7");

var $eYlij = parcelRequire("eYlij");
const $0e2ca0aa8f567d21$export$954e0f4d6ca6524 = (props)=>{
    const intl = (0, $8e22h.default)();
    const freePlanFeatureMessages = [
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.unlimitedCards.title",
                defaultMessage: "Unlimited cards"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.upTo10BoardsPerWorkspace.title",
                defaultMessage: "Up to 10 boards per Workspace"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.unlimitedPowerUpsPerBoard.title",
                defaultMessage: "Unlimited Power-Ups per board"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.unlimitedStorage.title.free",
                defaultMessage: "Unlimited storage (10MB/file)"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.workspaceCommandRuns.title",
                defaultMessage: "250 Workspace command runs per month"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.customBackgroundsAndStickers.title",
                defaultMessage: "Custom backgrounds & stickers"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.unlimitedActivityLog.title",
                defaultMessage: "Unlimited activity log"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.assigneeAndDueDates.title",
                defaultMessage: "Assignee and due dates"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.mobileApps.title",
                defaultMessage: "iOS and Android mobile apps"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.twoFactorAuthentication.title",
                defaultMessage: "2-factor authentication"
            })
        }
    ];
    const standardPlanFeatureMessages = [
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.unlimitedBoards.title",
                defaultMessage: "Unlimited boards"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.advancedChecklists.title",
                defaultMessage: "Advanced checklists"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.customFields.title",
                defaultMessage: "Custom Fields"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.unlimitedStorage.title",
                defaultMessage: "Unlimited storage (250MB/file)"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.workspaceCommandRuns.title",
                defaultMessage: "1,000 Workspace command runs per month"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.singleBoardGuests.title",
                defaultMessage: "Single board guests"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.savedSearches.title",
                defaultMessage: "Saved searches"
            })
        }
    ];
    const premiumPlanFeatureMessages = [
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.views.title",
                defaultMessage: "Views: Calendar, Timeline, Table, Dashboard, and Map"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.workspaceViews.title",
                defaultMessage: "Workspace views: Table and Calendar"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.unlimitedWorkspaceCommandRuns.title",
                defaultMessage: "Unlimited Workspace command runs"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.atlassianIntelligence.title",
                defaultMessage: "Atlassian Intelligence (AI)"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.adminAndSecurityFeatures.title",
                defaultMessage: "Admin and security features"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.workspaceLevelTemplates.title",
                defaultMessage: "Workspace-level templates"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.collections.title",
                defaultMessage: "Collections"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.observers.title",
                defaultMessage: "Observers"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.simpleDataExport.title",
                defaultMessage: "Simple data export"
            })
        }
    ];
    const trelloProductPlans = [
        {
            planName: "Free",
            offeringSku: "jira-servicedesk-free",
            recommendationLimit: 0,
            signupLimit: 150000,
            planFeatureMessages: freePlanFeatureMessages
        },
        {
            planName: "Standard",
            offeringSku: "trello-standard-non-profit",
            recommendationLimit: 10,
            signupLimit: 150000,
            planFeatureMessages: standardPlanFeatureMessages
        },
        {
            planName: "Premium",
            offeringSku: "trello-premium-non-profit",
            recommendationLimit: 250,
            signupLimit: 150000,
            planFeatureMessages: premiumPlanFeatureMessages
        }
    ];
    const messages = (0, $fnHPc.defineMessages)({
        headerText: {
            id: "TrelloPricingPage.priceFinder.headerText",
            defaultMessage: "Build Your <blue>Source of Truth</blue>"
        },
        unitCountInputTextRedesign: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        unitCountInputTerm: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputTerm",
            defaultMessage: "users"
        },
        billingCycleText: {
            id: "ConfluencePricingPage.priceFinder.billingCycleText",
            defaultMessage: "Billing cycle:"
        },
        unitCountInputText: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputText",
            defaultMessage: "How many users are on your team?"
        },
        unitCountInputTooltip: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputTooltip",
            defaultMessage: "A Confluence user is any user who can log in to Confluence, and who exists in User Management"
        },
        monthlyExampleHelpText: {
            id: "ConfluencePricingPage.priceFinder.monthlyExampleHelpText",
            defaultMessage: "Monthly plans give you flexibility as your number of active users changes, so pay for seats as you use them. Remember that the number of seats may change the total price."
        },
        annualExampleHelpText: {
            id: "ConfluencePricingPage.priceFinder.annualExampleHelpText",
            defaultMessage: "Annual plans give you flexibility and help you prepare for growth. Buy a group of seats at a flat rate now, then fill your empty seats through the year at no extra cost."
        },
        exampleStandardPlan: {
            id: "ConfluencePricingPage.priceFinder.exampleStandardPlan",
            defaultMessage: "Pricing for {unitCount} users on Standard plan",
            description: "Standard is a plan name and should not be translated"
        },
        cardOverSignupLimit: {
            id: "ConfluencePricingPage.priceFinder.cardOverSignupLimit",
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: "ConfluencePricingPage.priceFinder.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardUnitCountTierRange: {
            id: "ConfluencePricingPage.priceFinder.cardUnitCountTierRange",
            defaultMessage: "User tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "TrelloPricingPage.priceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per user / month"
        },
        cardFreeDescription: {
            id: "ConfluencePricingPage.priceFinder.cardFreeDescription",
            defaultMessage: "Always free for 10 users"
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hCc2m.default), {
        interactionName: "trello-price-finder",
        fallback: (0, $g9ZvA.LoadingSpinner),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eYlij.PriceFinderContextProvider), {
            dataProductKey: "trello",
            productPlans: trelloProductPlans,
            defaultUnitCount: 150,
            shouldAddDiscount: props.shouldAddDiscount,
            ctaUrlSource: "productPlans",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gIRO7.default), {
                messages: messages,
                serverSideCCPPricing: props.pricing?.ccpPricingData?.trello,
                countryCode: props.countryCode
            })
        })
    });
};
$0e2ca0aa8f567d21$export$954e0f4d6ca6524.displayName = "TrelloPriceFinder";

});



parcelRegister("jEVVm", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9BZqy"));

});
parcelRegister("9BZqy", function(module, exports) {
$parcel$export(module.exports, "unstable_now", function () { return $6ff737efae05bc89$export$c4744153514ff05d; }, function (v) { return $6ff737efae05bc89$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6ff737efae05bc89$export$3e506c1ccc9cc1a7; }, function (v) { return $6ff737efae05bc89$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6ff737efae05bc89$export$e26fe2ed2fa76875; }, function (v) { return $6ff737efae05bc89$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6ff737efae05bc89$export$502329bbf4b505b1; }, function (v) { return $6ff737efae05bc89$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6ff737efae05bc89$export$6e3807111c4874c4; }, function (v) { return $6ff737efae05bc89$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6ff737efae05bc89$export$c27134553091fb3a; }, function (v) { return $6ff737efae05bc89$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6ff737efae05bc89$export$33ee1acdc04fd2a2; }, function (v) { return $6ff737efae05bc89$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6ff737efae05bc89$export$b00a404bbd5edef2; }, function (v) { return $6ff737efae05bc89$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6ff737efae05bc89$export$d66a1c1c77bd778b; }, function (v) { return $6ff737efae05bc89$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6ff737efae05bc89$export$d3dfb8e4810cb555; }, function (v) { return $6ff737efae05bc89$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6ff737efae05bc89$export$72fdf0e06517287b; }, function (v) { return $6ff737efae05bc89$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6ff737efae05bc89$export$816d2913ae6b83b1; }, function (v) { return $6ff737efae05bc89$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6ff737efae05bc89$export$61bcfe829111a1d0; }, function (v) { return $6ff737efae05bc89$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6ff737efae05bc89$export$7ee8c9beb337bc3f; }, function (v) { return $6ff737efae05bc89$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6ff737efae05bc89$export$b5836b71941fa3ed; }, function (v) { return $6ff737efae05bc89$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6ff737efae05bc89$export$cf845f2c119da08a; }, function (v) { return $6ff737efae05bc89$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6ff737efae05bc89$export$c4744153514ff05d;
var $6ff737efae05bc89$export$3e506c1ccc9cc1a7;
var $6ff737efae05bc89$export$e26fe2ed2fa76875;
var $6ff737efae05bc89$export$502329bbf4b505b1;
var $6ff737efae05bc89$export$6e3807111c4874c4;
var $6ff737efae05bc89$export$c27134553091fb3a;
var $6ff737efae05bc89$export$33ee1acdc04fd2a2;
var $6ff737efae05bc89$export$b00a404bbd5edef2;
var $6ff737efae05bc89$export$d66a1c1c77bd778b;
var $6ff737efae05bc89$export$d3dfb8e4810cb555;
var $6ff737efae05bc89$export$72fdf0e06517287b;
var $6ff737efae05bc89$export$816d2913ae6b83b1;
var $6ff737efae05bc89$export$61bcfe829111a1d0;
var $6ff737efae05bc89$export$7ee8c9beb337bc3f;
var $6ff737efae05bc89$export$b5836b71941fa3ed;
var $6ff737efae05bc89$export$cf845f2c119da08a;
"use strict";
function $6ff737efae05bc89$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $6ff737efae05bc89$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $6ff737efae05bc89$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $6ff737efae05bc89$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $6ff737efae05bc89$var$compare(left, last)) rightIndex < length && 0 > $6ff737efae05bc89$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $6ff737efae05bc89$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $6ff737efae05bc89$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$6ff737efae05bc89$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6ff737efae05bc89$var$localPerformance = performance;
    $6ff737efae05bc89$export$c4744153514ff05d = function() {
        return $6ff737efae05bc89$var$localPerformance.now();
    };
} else {
    var $6ff737efae05bc89$var$localDate = Date, $6ff737efae05bc89$var$initialTime = $6ff737efae05bc89$var$localDate.now();
    $6ff737efae05bc89$export$c4744153514ff05d = function() {
        return $6ff737efae05bc89$var$localDate.now() - $6ff737efae05bc89$var$initialTime;
    };
}
var $6ff737efae05bc89$var$taskQueue = [], $6ff737efae05bc89$var$timerQueue = [], $6ff737efae05bc89$var$taskIdCounter = 1, $6ff737efae05bc89$var$currentTask = null, $6ff737efae05bc89$var$currentPriorityLevel = 3, $6ff737efae05bc89$var$isPerformingWork = !1, $6ff737efae05bc89$var$isHostCallbackScheduled = !1, $6ff737efae05bc89$var$isHostTimeoutScheduled = !1, $6ff737efae05bc89$var$needsPaint = !1, $6ff737efae05bc89$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $6ff737efae05bc89$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $6ff737efae05bc89$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $6ff737efae05bc89$var$advanceTimers(currentTime) {
    for(var timer = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$timerQueue); null !== timer;){
        if (null === timer.callback) $6ff737efae05bc89$var$pop($6ff737efae05bc89$var$timerQueue);
        else if (timer.startTime <= currentTime) $6ff737efae05bc89$var$pop($6ff737efae05bc89$var$timerQueue), timer.sortIndex = timer.expirationTime, $6ff737efae05bc89$var$push($6ff737efae05bc89$var$taskQueue, timer);
        else break;
        timer = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$timerQueue);
    }
}
function $6ff737efae05bc89$var$handleTimeout(currentTime) {
    $6ff737efae05bc89$var$isHostTimeoutScheduled = !1;
    $6ff737efae05bc89$var$advanceTimers(currentTime);
    if (!$6ff737efae05bc89$var$isHostCallbackScheduled) {
        if (null !== $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$taskQueue)) $6ff737efae05bc89$var$isHostCallbackScheduled = !0, $6ff737efae05bc89$var$isMessageLoopRunning || ($6ff737efae05bc89$var$isMessageLoopRunning = !0, $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$timerQueue);
            null !== firstTimer && $6ff737efae05bc89$var$requestHostTimeout($6ff737efae05bc89$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $6ff737efae05bc89$var$isMessageLoopRunning = !1, $6ff737efae05bc89$var$taskTimeoutID = -1, $6ff737efae05bc89$var$frameInterval = 5, $6ff737efae05bc89$var$startTime = -1;
function $6ff737efae05bc89$var$shouldYieldToHost() {
    return $6ff737efae05bc89$var$needsPaint ? !0 : $6ff737efae05bc89$export$c4744153514ff05d() - $6ff737efae05bc89$var$startTime < $6ff737efae05bc89$var$frameInterval ? !1 : !0;
}
function $6ff737efae05bc89$var$performWorkUntilDeadline() {
    $6ff737efae05bc89$var$needsPaint = !1;
    if ($6ff737efae05bc89$var$isMessageLoopRunning) {
        var currentTime = $6ff737efae05bc89$export$c4744153514ff05d();
        $6ff737efae05bc89$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $6ff737efae05bc89$var$isHostCallbackScheduled = !1;
                $6ff737efae05bc89$var$isHostTimeoutScheduled && ($6ff737efae05bc89$var$isHostTimeoutScheduled = !1, $6ff737efae05bc89$var$localClearTimeout($6ff737efae05bc89$var$taskTimeoutID), $6ff737efae05bc89$var$taskTimeoutID = -1);
                $6ff737efae05bc89$var$isPerformingWork = !0;
                var previousPriorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
                try {
                    b: {
                        $6ff737efae05bc89$var$advanceTimers(currentTime);
                        for($6ff737efae05bc89$var$currentTask = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$taskQueue); null !== $6ff737efae05bc89$var$currentTask && !($6ff737efae05bc89$var$currentTask.expirationTime > currentTime && $6ff737efae05bc89$var$shouldYieldToHost());){
                            var callback = $6ff737efae05bc89$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $6ff737efae05bc89$var$currentTask.callback = null;
                                $6ff737efae05bc89$var$currentPriorityLevel = $6ff737efae05bc89$var$currentTask.priorityLevel;
                                var continuationCallback = callback($6ff737efae05bc89$var$currentTask.expirationTime <= currentTime);
                                currentTime = $6ff737efae05bc89$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $6ff737efae05bc89$var$currentTask.callback = continuationCallback;
                                    $6ff737efae05bc89$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $6ff737efae05bc89$var$currentTask === $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$taskQueue) && $6ff737efae05bc89$var$pop($6ff737efae05bc89$var$taskQueue);
                                $6ff737efae05bc89$var$advanceTimers(currentTime);
                            } else $6ff737efae05bc89$var$pop($6ff737efae05bc89$var$taskQueue);
                            $6ff737efae05bc89$var$currentTask = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$taskQueue);
                        }
                        if (null !== $6ff737efae05bc89$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$timerQueue);
                            null !== firstTimer && $6ff737efae05bc89$var$requestHostTimeout($6ff737efae05bc89$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $6ff737efae05bc89$var$currentTask = null, $6ff737efae05bc89$var$currentPriorityLevel = previousPriorityLevel, $6ff737efae05bc89$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline() : $6ff737efae05bc89$var$isMessageLoopRunning = !1;
        }
    }
}
var $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $6ff737efae05bc89$var$localSetImmediate) $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline = function() {
    $6ff737efae05bc89$var$localSetImmediate($6ff737efae05bc89$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6ff737efae05bc89$var$channel = new MessageChannel(), $6ff737efae05bc89$var$port = $6ff737efae05bc89$var$channel.port2;
    $6ff737efae05bc89$var$channel.port1.onmessage = $6ff737efae05bc89$var$performWorkUntilDeadline;
    $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline = function() {
        $6ff737efae05bc89$var$port.postMessage(null);
    };
} else $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline = function() {
    $6ff737efae05bc89$var$localSetTimeout($6ff737efae05bc89$var$performWorkUntilDeadline, 0);
};
function $6ff737efae05bc89$var$requestHostTimeout(callback, ms) {
    $6ff737efae05bc89$var$taskTimeoutID = $6ff737efae05bc89$var$localSetTimeout(function() {
        callback($6ff737efae05bc89$export$c4744153514ff05d());
    }, ms);
}
$6ff737efae05bc89$export$3e506c1ccc9cc1a7 = 5;
$6ff737efae05bc89$export$e26fe2ed2fa76875 = 1;
$6ff737efae05bc89$export$502329bbf4b505b1 = 4;
$6ff737efae05bc89$export$6e3807111c4874c4 = 3;
$6ff737efae05bc89$export$c27134553091fb3a = null;
$6ff737efae05bc89$export$33ee1acdc04fd2a2 = 2;
$6ff737efae05bc89$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$6ff737efae05bc89$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6ff737efae05bc89$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$6ff737efae05bc89$export$d3dfb8e4810cb555 = function() {
    return $6ff737efae05bc89$var$currentPriorityLevel;
};
$6ff737efae05bc89$export$72fdf0e06517287b = function(eventHandler) {
    switch($6ff737efae05bc89$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
    $6ff737efae05bc89$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $6ff737efae05bc89$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$6ff737efae05bc89$export$816d2913ae6b83b1 = function() {
    $6ff737efae05bc89$var$needsPaint = !0;
};
$6ff737efae05bc89$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
    $6ff737efae05bc89$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $6ff737efae05bc89$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$6ff737efae05bc89$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $6ff737efae05bc89$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $6ff737efae05bc89$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $6ff737efae05bc89$var$push($6ff737efae05bc89$var$timerQueue, priorityLevel), null === $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$taskQueue) && priorityLevel === $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$timerQueue) && ($6ff737efae05bc89$var$isHostTimeoutScheduled ? ($6ff737efae05bc89$var$localClearTimeout($6ff737efae05bc89$var$taskTimeoutID), $6ff737efae05bc89$var$taskTimeoutID = -1) : $6ff737efae05bc89$var$isHostTimeoutScheduled = !0, $6ff737efae05bc89$var$requestHostTimeout($6ff737efae05bc89$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $6ff737efae05bc89$var$push($6ff737efae05bc89$var$taskQueue, priorityLevel), $6ff737efae05bc89$var$isHostCallbackScheduled || $6ff737efae05bc89$var$isPerformingWork || ($6ff737efae05bc89$var$isHostCallbackScheduled = !0, $6ff737efae05bc89$var$isMessageLoopRunning || ($6ff737efae05bc89$var$isMessageLoopRunning = !0, $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$6ff737efae05bc89$export$b5836b71941fa3ed = $6ff737efae05bc89$var$shouldYieldToHost;
$6ff737efae05bc89$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
        $6ff737efae05bc89$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $6ff737efae05bc89$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("ixLXc", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bOBs2"));

});
parcelRegister("bOBs2", function(module, exports) {
$parcel$export(module.exports, "useSyncExternalStore", function () { return $89a16a416bb12add$export$306c0aa65ff9ec16; }, function (v) { return $89a16a416bb12add$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $89a16a416bb12add$export$306c0aa65ff9ec16;
'use strict';

var $1oC0p = parcelRequire("1oC0p");
function $89a16a416bb12add$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $89a16a416bb12add$var$k = "function" === typeof Object.is ? Object.is : $89a16a416bb12add$var$h, $89a16a416bb12add$var$l = $1oC0p.useState, $89a16a416bb12add$var$m = $1oC0p.useEffect, $89a16a416bb12add$var$n = $1oC0p.useLayoutEffect, $89a16a416bb12add$var$p = $1oC0p.useDebugValue;
function $89a16a416bb12add$var$q(a, b) {
    var d = b(), f = $89a16a416bb12add$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $89a16a416bb12add$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $89a16a416bb12add$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $89a16a416bb12add$var$m(function() {
        $89a16a416bb12add$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $89a16a416bb12add$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $89a16a416bb12add$var$p(d);
    return d;
}
function $89a16a416bb12add$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$89a16a416bb12add$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $89a16a416bb12add$var$t(a, b) {
    return b();
}
var $89a16a416bb12add$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $89a16a416bb12add$var$t : $89a16a416bb12add$var$q;
$89a16a416bb12add$export$306c0aa65ff9ec16 = void 0 !== $1oC0p.useSyncExternalStore ? $1oC0p.useSyncExternalStore : $89a16a416bb12add$var$u;

});


parcelRegister("hBYvx", function(module, exports) {
$parcel$export(module.exports, "Video", function () { return $5a5d9245727e1968$export$ae01dedf5c052bb; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $5a5d9245727e1968$var$videoStyle = (ratio)=>{
    const aspectRatioCSS = ratio && ratio !== "none" ? {
        aspectRatio: ratio,
        objectFit: "cover"
    } : {};
    return {
        maxWidth: "100%",
        ...aspectRatioCSS
    };
};
const $5a5d9245727e1968$export$ae01dedf5c052bb = ({ videoLink: videoLink, videoType: videoType, videoPreviewImage: videoPreviewImage, loop: loop = true, muted: muted = true, aspectRatio: aspectRatio, alternativeSources: alternativeSources, className: className, fallbackText: fallbackText, onEnded: onEnded, children: children })=>{
    const videoRef = (0, $1oC0p.useRef)(null);
    // reload video player if video source prop changes dynamically
    (0, $1oC0p.useEffect)(()=>{
        videoRef.current?.load();
    }, [
        videoLink
    ]);
    return(// eslint-disable-next-line jsx-a11y/media-has-caption
    /*#__PURE__*/ (0, $7VQPk.jsxs)("video", {
        playsInline: true,
        muted: muted,
        preload: "auto",
        poster: videoPreviewImage,
        autoPlay: true,
        className: className,
        style: $5a5d9245727e1968$var$videoStyle(aspectRatio),
        loop: loop,
        ref: videoRef,
        onEnded: onEnded,
        children: [
            fallbackText,
            /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                src: videoLink,
                type: `video/${videoType ? videoType : "mp4"}`
            }),
            alternativeSources ? alternativeSources.map((source, index)=>{
                return /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                    src: source.videoLink,
                    type: `video/${source.videoType ? source.videoType : "mp4"}`
                }, index);
            }) : null,
            children
        ]
    }));
};

});

parcelRegister("92jF6", function(module, exports) {
$parcel$export(module.exports, "Card", function () { return $b6adcd00aae9005f$export$60332b2344f7fe41; });
/* card.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $2ivuE = parcelRequire("2ivuE");
const $b6adcd00aae9005f$var$containerStyles = null;
const $b6adcd00aae9005f$var$contentBlockStyles = null;
const $b6adcd00aae9005f$var$barStyles = null;
const $b6adcd00aae9005f$export$60332b2344f7fe41 = (props)=>{
    const { textColor: textColor, headerType: headerType, headerText: headerText, bodyText: bodyText, eyebrowText: eyebrowText, footerHeader: footerHeader, footerText: footerText, imageLink: imageLink, imageAltText: imageAltText, backgroundColor: backgroundColor, colorBars: colorBars, iconName: iconName, iconColor: iconColor, iconSize: iconSize, barColor: barColor = "", className: className, ctaProps: ctaProps, aspectRatio: aspectRatio, orientation: orientation, pictureProps: pictureProps, clickableCardUrl: clickableCardUrl } = props;
    if (imageLink && !imageAltText) throw new Error("If using an image, please provide an alt text for accessibility purposes!");
    const cardBackBackgroundColor = backgroundColor ?? "#ffffff";
    const cardBackTextColor = textColor ?? "#091e42";
    const cardBackColor = null;
    const contentBlockIconColor = iconColor ?? "#091e42";
    const handleClick = ()=>{
        if (clickableCardUrl) window.location.href = clickableCardUrl;
    };
    const clickableCardStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_2rkoyh40 _16qs1nta _1e0c1txw _2lx21bp4 _p12fg505 _7cca15wb _4t3i1osq",
            "_bfhk16d1 _syazn54i",
            "_80om1wzl",
            className
        ]),
        onClick: handleClick,
        style: {
            "--_1vkwvj7": (0, $6ZVlx.default)(cardBackBackgroundColor),
            "--_1dl5pj2": (0, $6ZVlx.default)(cardBackTextColor),
            "--_8vvi5m": (0, $6ZVlx.default)(clickableCardUrl ? "pointer" : "default")
        },
        children: [
            colorBars === "top" || colorBars === "both" ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: {
                    backgroundColor: barColor,
                    borderTopRightRadius: "4px",
                    borderTopLeftRadius: "4px"
                },
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _4t3iftgi"
                ])
            }) : "",
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), {
                cardStyle: true,
                aspectRatio: aspectRatio,
                orientation: orientation,
                headerType: headerType,
                headerText: headerText,
                bodyText: bodyText,
                imageLink: imageLink,
                imageAltText: imageAltText,
                eyebrowText: eyebrowText,
                footerHeader: footerHeader,
                footerText: footerText,
                iconColor: contentBlockIconColor,
                iconName: iconName,
                iconSize: iconSize,
                ctaProps: ctaProps,
                pictureProps: pictureProps,
                className: (0, $2jatx.default)([
                    "_4t3i1osq"
                ])
            }),
            colorBars === "bottom" || colorBars === "both" ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: {
                    backgroundColor: barColor,
                    borderBottomRightRadius: "4px",
                    borderBottomLeftRadius: "4px"
                },
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _4t3iftgi"
                ])
            }) : ""
        ]
    });
};

});


var $5UKqd = parcelRequire("5UKqd");

var $6mvtm = parcelRequire("6mvtm");

var $3t7DW = parcelRequire("3t7DW");

var $7Lagj = parcelRequire("7Lagj");
(0, $3t7DW.init)((0, $7Lagj.NonProfitPricingPage), (0, $5UKqd.PricingPageRelayQuery), (0, $5UKqd.getPricingPageRelayQueryVars)("nonprofit", window.location), (0, $6mvtm.RELAY_API_CONTENTFUL));


//# sourceMappingURL=non-profit-pricing-page.1058e69e.js.map
